var _defs, _path, _g, _g2, _path2, _path3, _path4, _g3, _g4, _path5, _g5, _g6, _g7, _g8, _path6, _g9, _path7, _polygon, _polygon2, _polygon3, _polygon4, _path8, _path9, _path0, _polygon5, _polygon6, _polygon7, _polygon8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReferralPic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 227.98 209.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        clip-path: url(#clippath-6);\n      }\n\n      .st1 {\n        clip-path: url(#clippath-7);\n      }\n\n      .st2 {\n        clip-path: url(#clippath-4);\n      }\n\n      .st3, .st4, .st5, .st6 {\n        clip-rule: evenodd;\n      }\n\n      .st3, .st7, .st8 {\n        fill: #70f9f4;\n      }\n\n      .st9 {\n        fill: #fff;\n      }\n\n      .st9, .st10, .st11, .st7, .st12, .st13 {\n        fill-rule: evenodd;\n      }\n\n      .st14, .st10, .st6 {\n        fill: #04c5e7;\n      }\n\n      .st15 {\n        clip-path: url(#clippath-1);\n      }\n\n      .st16 {\n        clip-path: url(#clippath-5);\n      }\n\n      .st17 {\n        clip-path: url(#clippath-8);\n      }\n\n      .st18 {\n        clip-path: url(#clippath-3);\n      }\n\n      .st4, .st19 {\n        fill: none;\n      }\n\n      .st11 {\n        fill: #feb31e;\n      }\n\n      .st5, .st13 {\n        fill: #00a6b7;\n      }\n\n      .st20 {\n        clip-path: url(#clippath-2);\n      }\n\n      .st19 {\n        stroke: #09a3f0;\n        stroke-miterlimit: 22.93;\n        stroke-width: .48px;\n      }\n\n      .st12 {\n        fill: #f5f5f5;\n      }\n\n      .st21 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M18.37,106.64c23.57-7.52,44.6-17.75,59.99-33.31-.24,11.24,1.68,24.43,5.97,38.12,4.64,14.81,11.31,27.81,18.69,37.55-25.37-4.84-58.62,5.54-70.05,8.41-1.5.38-2.9.66-4.44.85-15.08,1.87-23.62-6.2-27.38-20.92-3.93-15.38,2.23-25.74,17.21-30.7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M52.67,152.4l.28,12.28c.08,3.7.32,4.73,1.26,7.16l8.63,22.43c2.62,12.94-15.61,19.29-20.63,6.23l-14.88-42.11c.4-.04.81-.08,1.22-.13,1.54-.19,2.94-.47,4.44-.85,4.15-1.04,11.19-3.08,19.69-5.01"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M52.95,164.68l-.28-12.28c-1.7.39-3.34.78-4.91,1.16-.28,4.17.03,8.36.48,15.85.46,4.87,3.98,3.52,5.92,2.3-.89-2.34-1.13-3.39-1.21-7.03"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M51.61,191.14c-3.85-14.08-6.86-26.39-5.67-37.12-5.47,1.38-9.97,2.64-12.96,3.4-.73.18-1.44.34-2.15.48l5.25,2.32c1.12.49,1.94,1.26,2.45,2.37l13.09,28.56Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M97.92,49.02c13.96-3.57,32.9,17.88,42.29,47.9,9.39,30.03,5.68,57.26-8.28,60.83-13.96,3.57-32.9-17.88-42.29-47.9-9.39-30.03-5.68-57.26,8.28-60.83"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M84.66,84.36l23.83-2.8,13.65,43.57-20.64,11.01c-4.64-7.44-8.77-16.39-11.86-26.27-2.79-8.93-4.43-17.61-4.98-25.5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M131.93,157.76c4.86-1.24,8.48-5.35,10.74-11.45l-36.13-2.95c8.34,10.65,17.63,16.39,25.4,14.41"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M84.73,72.16l22.87-22.08c-3.36-1.42-6.63-1.83-9.67-1.05-7.53,1.92-12.08,10.73-13.2,23.14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M108.48,81.56c5.66-1.45,13.3,7.13,17.07,19.16,3.77,12.03,2.24,22.95-3.42,24.4-5.66,1.45-13.3-7.13-17.07-19.16-3.77-12.03-2.24-22.95,3.42-24.4"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M94.24,40.7c16.4-4.19,38.56,20.68,49.5,55.56,10.93,34.88,6.5,66.56-9.91,70.75-16.4,4.19-38.56-20.68-49.5-55.56-10.93-34.88-6.5-66.56,9.91-70.75"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st14",
    x: -2.77,
    y: 73.33,
    width: 105.8,
    height: 86.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st14",
    x: 27.32,
    y: 152.4,
    width: 38.14,
    height: 61.16
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M54.16,171.71l.05.13,8.63,22.43v.04c-3.48-.4-6.8-2.6-8.54-7.12l-5.61-15.87c1.11,2.53,3.85,1.41,5.47.39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M103.02,149c-5.69-7.5-10.95-16.95-15.19-27.65,1.2,5.94,2.3,17.32-9.94,19.19-21.12,3.23-42.8,11.28-51.52,13.46-1.5.38-2.9.66-4.44.85-4.21.52-7.91.27-11.14-.69,4.22,3.32,9.67,4.84,16.53,4.22.4-.04.81-.08,1.22-.13,1.54-.19,2.94-.47,4.44-.85,4.15-1.04,11.19-3.08,19.69-5.01,14.87-3.39,34.21-6.47,50.35-3.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M16.4,116.38c22.38-8.37,50.81-16.25,62.67-29.12-.33-2.77-.54-5.47-.65-8.09-15.82,14.62-36.82,24.51-60.21,31.92-9.64,3.17-15.79,8.39-18.12,15.58-.07.81-.1,1.65-.09,2.5,2.73-5.82,8.26-10.1,16.4-12.79"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M52.95,164.68l-.28-12.28c-1.7.39-3.34.78-4.91,1.16-.28,4.17.03,8.36.48,15.85.46,4.87,3.98,3.52,5.92,2.3-.89-2.34-1.13-3.39-1.21-7.03"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    x: 47.48,
    y: 152.4,
    width: 6.68,
    height: 21.88
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st8",
    x: 30.82,
    y: 154.01,
    width: 20.79,
    height: 37.12
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M25.82,158.49c-8.09-3.4-13.39-11.73-16.46-23.74-2.73-10.7-1.77-19.19,2.63-25.39-1.84,1-3.47,2.13-4.9,3.37-3.06,5.91-3.48,13.56-1.1,22.88,2.76,10.8,7.33,18.64,14.12,22.57,1.78.29,3.68.4,5.71.3"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M97.92,49.02c13.96-3.57,32.9,17.88,42.29,47.9,9.39,30.03,5.68,57.26-8.28,60.83-13.96,3.57-32.9-17.88-42.29-47.9-9.39-30.03-5.68-57.26,8.28-60.83"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "156.65 151.04 156.59 151.06 124.31 40.78 124.38 40.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "156.69 151.03 156.38 151.12 124.1 40.85 124.41 40.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "156.48 151.09 156.17 151.18 123.89 40.91 124.21 40.81"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "156.27 151.15 155.96 151.25 123.68 40.97 124 40.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "156.06 151.21 155.75 151.31 123.48 41.03 123.79 40.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "155.86 151.28 155.54 151.37 123.27 41.09 123.58 41"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "155.65 151.34 155.33 151.43 123.06 41.15 123.37 41.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "155.44 151.4 155.13 151.49 122.85 41.21 123.16 41.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "155.23 151.46 154.92 151.55 122.64 41.27 122.95 41.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "155.02 151.52 154.71 151.61 122.43 41.33 122.75 41.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "154.81 151.58 154.5 151.67 122.22 41.39 122.54 41.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "154.6 151.64 154.29 151.73 122.02 41.46 122.33 41.36"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "154.4 151.7 154.08 151.79 121.81 41.52 122.12 41.43"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "154.19 151.76 153.87 151.86 121.6 41.58 121.91 41.49"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "153.98 151.83 153.67 151.92 121.39 41.64 121.7 41.55"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "153.77 151.89 153.46 151.98 121.18 41.7 121.49 41.61"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "153.56 151.95 153.25 152.04 120.97 41.76 121.29 41.67"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "153.35 152.01 153.04 152.1 120.76 41.82 121.08 41.73"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "153.14 152.07 152.83 152.16 120.56 41.88 120.87 41.79"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "152.94 152.13 152.62 152.22 120.35 41.94 120.66 41.85"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "152.73 152.19 152.41 152.28 120.14 42 120.45 41.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "152.52 152.25 152.21 152.34 119.93 42.07 120.24 41.97"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "152.31 152.31 152 152.41 119.72 42.13 120.03 42.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "152.1 152.37 151.79 152.47 119.51 42.19 119.83 42.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "151.89 152.44 151.58 152.53 119.3 42.25 119.62 42.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "151.68 152.5 151.37 152.59 119.1 42.31 119.41 42.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "151.48 152.56 151.16 152.65 118.89 42.37 119.2 42.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "151.27 152.62 150.95 152.71 118.68 42.43 118.99 42.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "151.06 152.68 150.75 152.77 118.47 42.49 118.78 42.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "150.85 152.74 150.54 152.83 118.26 42.55 118.57 42.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "150.64 152.8 150.33 152.89 118.05 42.62 118.37 42.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "150.43 152.86 150.12 152.95 117.84 42.68 118.16 42.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "150.22 152.92 149.91 153.02 117.64 42.74 117.95 42.65"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "150.02 152.98 149.7 153.08 117.43 42.8 117.74 42.71"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "149.81 153.05 149.49 153.14 117.22 42.86 117.53 42.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "149.6 153.11 149.29 153.2 117.01 42.92 117.32 42.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "149.39 153.17 149.08 153.26 116.8 42.98 117.12 42.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "149.18 153.23 148.87 153.32 116.59 43.04 116.91 42.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "148.97 153.29 148.66 153.38 116.39 43.1 116.7 43.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "148.76 153.35 148.45 153.44 116.18 43.16 116.49 43.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "148.56 153.41 148.24 153.5 115.97 43.23 116.28 43.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "148.35 153.47 148.03 153.56 115.76 43.29 116.07 43.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "148.14 153.53 147.83 153.63 115.55 43.35 115.86 43.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "147.93 153.59 147.62 153.69 115.34 43.41 115.66 43.32"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "147.72 153.66 147.41 153.75 115.13 43.47 115.45 43.38"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "147.51 153.72 147.2 153.81 114.93 43.53 115.24 43.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "147.3 153.78 146.99 153.87 114.72 43.59 115.03 43.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "147.1 153.84 146.78 153.93 114.51 43.65 114.82 43.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "146.89 153.9 146.57 153.99 114.3 43.71 114.61 43.62"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "146.68 153.96 146.37 154.05 114.09 43.78 114.4 43.68"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "146.47 154.02 146.16 154.11 113.88 43.84 114.2 43.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "146.26 154.08 145.95 154.17 113.67 43.9 113.99 43.81"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "146.05 154.14 145.74 154.24 113.47 43.96 113.78 43.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "145.84 154.21 145.53 154.3 113.26 44.02 113.57 43.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "145.64 154.27 145.32 154.36 113.05 44.08 113.36 43.99"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "145.43 154.33 145.12 154.42 112.84 44.14 113.15 44.05"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "145.22 154.39 144.91 154.48 112.63 44.2 112.94 44.11"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "145.01 154.45 144.7 154.54 112.42 44.26 112.74 44.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "144.8 154.51 144.49 154.6 112.21 44.32 112.53 44.23"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "144.59 154.57 144.28 154.66 112.01 44.39 112.32 44.29"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "144.39 154.63 144.07 154.72 111.8 44.45 112.11 44.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "144.18 154.69 143.86 154.79 111.59 44.51 111.9 44.42"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "143.97 154.75 143.66 154.85 111.38 44.57 111.69 44.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "143.76 154.82 143.45 154.91 111.17 44.63 111.48 44.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "143.55 154.88 143.24 154.97 110.96 44.69 111.28 44.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "143.34 154.94 143.03 155.03 110.75 44.75 111.07 44.66"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "143.13 155 142.82 155.09 110.55 44.81 110.86 44.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "142.93 155.06 142.61 155.15 110.34 44.87 110.65 44.78"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "142.72 155.12 142.4 155.21 110.13 44.94 110.44 44.84"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "142.51 155.18 142.2 155.27 109.92 45 110.23 44.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "142.3 155.24 141.99 155.33 109.71 45.06 110.02 44.97"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "142.09 155.3 141.78 155.4 109.5 45.12 109.82 45.03"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "141.88 155.37 141.57 155.46 109.29 45.18 109.61 45.09"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "141.67 155.43 141.36 155.52 109.09 45.24 109.4 45.15"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "141.47 155.49 141.15 155.58 108.88 45.3 109.19 45.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "141.26 155.55 140.94 155.64 108.67 45.36 108.98 45.27"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "141.05 155.61 140.74 155.7 108.46 45.42 108.77 45.33"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "140.84 155.67 140.53 155.76 108.25 45.48 108.56 45.39"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "140.63 155.73 140.32 155.82 108.04 45.55 108.36 45.45"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "140.42 155.79 140.11 155.88 107.83 45.61 108.15 45.51"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "140.21 155.85 139.9 155.95 107.63 45.67 107.94 45.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "140.01 155.91 139.69 156.01 107.42 45.73 107.73 45.64"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "139.8 155.98 139.48 156.07 107.21 45.79 107.52 45.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "139.59 156.04 139.28 156.13 107 45.85 107.31 45.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "139.38 156.1 139.07 156.19 106.79 45.91 107.1 45.82"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "139.17 156.16 138.86 156.25 106.58 45.97 106.9 45.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "138.96 156.22 138.65 156.31 106.37 46.03 106.69 45.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "138.75 156.28 138.44 156.37 106.17 46.09 106.48 46"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "138.55 156.34 138.23 156.43 105.96 46.16 106.27 46.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "138.34 156.4 138.02 156.49 105.75 46.22 106.06 46.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "138.13 156.46 137.82 156.56 105.54 46.28 105.85 46.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "137.92 156.53 137.61 156.62 105.33 46.34 105.64 46.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "137.71 156.59 137.4 156.68 105.12 46.4 105.44 46.31"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "137.5 156.65 137.19 156.74 104.91 46.46 105.23 46.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "137.29 156.71 136.98 156.8 104.71 46.52 105.02 46.43"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "137.09 156.77 136.77 156.86 104.5 46.58 104.81 46.49"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "136.88 156.83 136.56 156.92 104.29 46.64 104.6 46.55"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "136.67 156.89 136.36 156.98 104.08 46.71 104.39 46.61"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "136.46 156.95 136.15 157.04 103.87 46.77 104.18 46.67"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "136.25 157.01 135.94 157.1 103.66 46.83 103.98 46.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "136.04 157.07 135.73 157.17 103.45 46.89 103.77 46.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "135.83 157.14 135.52 157.23 103.25 46.95 103.56 46.86"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "135.63 157.2 135.31 157.29 103.04 47.01 103.35 46.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "135.42 157.26 135.1 157.35 102.83 47.07 103.14 46.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "135.21 157.32 134.9 157.41 102.62 47.13 102.93 47.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "135 157.38 134.69 157.47 102.41 47.19 102.72 47.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "134.79 157.44 134.48 157.53 102.2 47.25 102.52 47.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "134.58 157.5 134.27 157.59 102 47.32 102.31 47.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "134.37 157.56 134.06 157.65 101.79 47.38 102.1 47.29"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "134.17 157.62 133.85 157.71 101.58 47.44 101.89 47.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "133.96 157.68 133.65 157.78 101.37 47.5 101.68 47.41"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "133.75 157.75 133.44 157.84 101.16 47.56 101.47 47.47"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "133.54 157.81 133.23 157.9 100.95 47.62 101.27 47.53"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "133.33 157.87 133.02 157.96 100.74 47.68 101.06 47.59"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "133.12 157.93 132.81 158.02 100.54 47.74 100.85 47.65"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "132.92 157.99 132.6 158.08 100.33 47.8 100.64 47.71"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "132.71 158.05 132.39 158.14 100.12 47.86 100.43 47.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "132.5 158.11 132.19 158.2 99.91 47.93 100.22 47.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "132.29 158.17 131.98 158.26 99.7 47.99 100.01 47.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "132.08 158.23 131.77 158.33 99.49 48.05 99.81 47.96"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "131.87 158.29 131.56 158.39 99.28 48.11 99.6 48.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "131.66 158.36 131.35 158.45 99.08 48.17 99.39 48.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "131.46 158.42 131.14 158.51 98.87 48.23 99.18 48.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "131.25 158.48 130.93 158.57 98.66 48.29 98.97 48.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "131.04 158.54 130.73 158.63 98.45 48.35 98.76 48.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "130.83 158.6 130.52 158.69 98.24 48.41 98.55 48.32"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "130.62 158.66 130.31 158.75 98.03 48.48 98.35 48.38"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "130.41 158.72 130.1 158.81 97.82 48.54 98.14 48.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "130.2 158.78 129.89 158.87 97.62 48.6 97.93 48.51"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "130 158.84 129.68 158.94 97.41 48.66 97.72 48.57"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "129.79 158.91 129.47 159 97.2 48.72 97.51 48.63"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "129.58 158.97 129.27 159.06 96.99 48.78 97.3 48.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "129.37 159.03 129.06 159.12 96.78 48.84 97.09 48.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "129.16 159.09 128.85 159.18 96.57 48.9 96.89 48.81"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "128.95 159.15 128.64 159.24 96.36 48.96 96.68 48.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "128.74 159.21 128.43 159.3 96.16 49.02 96.47 48.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "128.54 159.27 128.22 159.36 95.95 49.09 96.26 48.99"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "128.33 159.33 128.01 159.42 95.74 49.15 96.05 49.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "128.12 159.39 127.81 159.49 95.53 49.21 95.84 49.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "127.91 159.46 127.6 159.55 95.32 49.27 95.63 49.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "127.7 159.52 127.39 159.61 95.11 49.33 95.43 49.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "127.49 159.58 127.18 159.67 94.9 49.39 95.22 49.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "127.28 159.64 126.97 159.73 94.7 49.45 95.01 49.36"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "127.08 159.7 126.76 159.79 94.49 49.51 94.8 49.42"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "126.87 159.76 126.55 159.85 94.28 49.57 94.59 49.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "126.66 159.82 126.35 159.91 94.07 49.63 94.38 49.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "126.45 159.88 126.14 159.97 93.86 49.7 94.17 49.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "126.24 159.94 125.93 160.03 93.65 49.76 93.97 49.67"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "126.03 160 125.72 160.1 93.44 49.82 93.76 49.73"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "125.82 160.06 125.51 160.16 93.24 49.88 93.55 49.79"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "125.62 160.13 125.3 160.22 93.03 49.94 93.34 49.85"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "125.41 160.19 125.09 160.28 92.82 50 93.13 49.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "125.2 160.25 124.89 160.34 92.61 50.06 92.92 49.97"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "124.99 160.31 124.68 160.4 92.4 50.12 92.71 50.03"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "124.78 160.37 124.47 160.46 92.19 50.18 92.51 50.09"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "124.57 160.43 124.26 160.52 91.98 50.25 92.3 50.15"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "124.36 160.49 124.05 160.58 91.78 50.31 92.09 50.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "124.16 160.55 123.84 160.64 91.57 50.37 91.88 50.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "123.95 160.61 123.63 160.71 91.36 50.43 91.67 50.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "123.74 160.68 123.43 160.77 91.15 50.49 91.46 50.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "123.53 160.74 123.22 160.83 90.94 50.55 91.26 50.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "123.32 160.8 123.01 160.89 90.73 50.61 91.05 50.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "123.11 160.86 122.8 160.95 90.53 50.67 90.84 50.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "122.91 160.92 122.59 161.01 90.32 50.73 90.63 50.64"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "122.7 160.98 122.38 161.07 90.11 50.79 90.42 50.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "122.49 161.04 122.18 161.13 89.9 50.86 90.21 50.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "122.28 161.1 121.97 161.19 89.69 50.92 90 50.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "122.07 161.16 121.76 161.25 89.48 50.98 89.8 50.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "121.86 161.22 121.55 161.32 89.27 51.04 89.59 50.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "121.65 161.29 121.34 161.38 89.07 51.1 89.38 51.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "121.45 161.35 121.13 161.44 88.86 51.16 89.17 51.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "121.24 161.41 120.92 161.5 88.65 51.22 88.96 51.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "121.03 161.47 120.72 161.56 88.44 51.28 88.75 51.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "120.82 161.53 120.51 161.62 88.23 51.34 88.54 51.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "120.61 161.59 120.3 161.68 88.02 51.4 88.34 51.31"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "120.4 161.65 120.09 161.74 87.81 51.47 88.13 51.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "120.19 161.71 119.88 161.8 87.61 51.53 87.92 51.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "119.99 161.77 119.67 161.87 87.4 51.59 87.71 51.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "119.78 161.83 119.46 161.93 87.19 51.65 87.5 51.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "119.57 161.9 119.26 161.99 86.98 51.71 87.29 51.62"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "119.36 161.96 119.05 162.05 86.77 51.77 87.08 51.68"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "119.15 162.02 118.84 162.11 86.56 51.83 86.88 51.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "118.94 162.08 118.63 162.17 86.35 51.89 86.67 51.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "118.73 162.14 118.42 162.23 86.15 51.95 86.46 51.86"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "118.53 162.2 118.21 162.29 85.94 52.02 86.25 51.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "118.32 162.26 118 162.35 85.73 52.08 86.04 51.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "118.11 162.32 117.8 162.41 85.52 52.14 85.83 52.05"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "117.9 162.38 117.59 162.48 85.31 52.2 85.62 52.11"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "117.69 162.45 117.38 162.54 85.1 52.26 85.42 52.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "117.48 162.51 117.17 162.6 84.89 52.32 85.21 52.23"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "117.27 162.57 116.96 162.66 84.69 52.38 85 52.29"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "117.07 162.63 116.75 162.72 84.48 52.44 84.79 52.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "116.86 162.69 116.54 162.78 84.27 52.5 84.58 52.41"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "116.65 162.75 116.34 162.84 84.06 52.56 84.37 52.47"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "116.44 162.81 116.13 162.9 83.85 52.63 84.16 52.53"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "116.23 162.87 115.92 162.96 83.64 52.69 83.96 52.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "116.02 162.93 115.71 163.03 83.43 52.75 83.75 52.66"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "115.81 163 115.5 163.09 83.23 52.81 83.54 52.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "115.61 163.06 115.29 163.15 83.02 52.87 83.33 52.78"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "115.4 163.12 115.08 163.21 82.81 52.93 83.12 52.84"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "115.19 163.18 114.88 163.27 82.6 52.99 82.91 52.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "114.98 163.24 114.67 163.33 82.39 53.05 82.7 52.96"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "114.77 163.3 114.46 163.39 82.18 53.11 82.5 53.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "114.56 163.36 114.25 163.45 81.97 53.17 82.29 53.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "114.35 163.42 114.04 163.51 81.77 53.24 82.08 53.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "114.15 163.48 113.83 163.58 81.56 53.3 81.87 53.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "113.94 163.54 113.62 163.64 81.35 53.36 81.66 53.27"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "113.73 163.61 113.42 163.7 81.14 53.42 81.45 53.33"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "113.52 163.67 113.21 163.76 80.93 53.48 81.24 53.39"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "113.31 163.73 113 163.82 80.72 53.54 81.04 53.45"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "113.1 163.79 112.79 163.88 80.51 53.6 80.83 53.51"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "112.89 163.85 112.58 163.94 80.31 53.66 80.62 53.57"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "112.69 163.91 112.37 164 80.1 53.72 80.41 53.63"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "112.48 163.97 112.16 164.06 79.89 53.79 80.2 53.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "112.27 164.03 111.96 164.12 79.68 53.85 79.99 53.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "112.06 164.09 111.75 164.19 79.47 53.91 79.78 53.82"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "111.85 164.15 111.54 164.25 79.26 53.97 79.58 53.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "111.64 164.22 111.33 164.31 79.05 54.03 79.37 53.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "111.43 164.28 111.12 164.37 78.85 54.09 79.16 54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "111.23 164.34 110.91 164.43 78.64 54.15 78.95 54.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "111.02 164.4 110.7 164.49 78.43 54.21 78.74 54.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "110.81 164.46 110.5 164.55 78.22 54.27 78.53 54.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "110.6 164.52 110.29 164.61 78.01 54.33 78.32 54.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "110.39 164.58 110.08 164.67 77.8 54.4 78.12 54.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "110.18 164.64 109.87 164.73 77.59 54.46 77.91 54.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "109.97 164.7 109.66 164.79 77.39 54.52 77.7 54.43"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "109.77 164.76 109.45 164.86 77.18 54.58 77.49 54.49"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "109.56 164.83 109.24 164.92 76.97 54.64 77.28 54.55"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "109.35 164.89 109.04 164.98 76.76 54.7 77.07 54.61"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "109.14 164.95 108.83 165.04 76.55 54.76 76.87 54.67"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "108.93 165.01 108.62 165.1 76.34 54.82 76.66 54.73"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "108.72 165.07 108.41 165.16 76.14 54.88 76.45 54.79"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "108.51 165.13 108.2 165.22 75.93 54.94 76.24 54.85"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "108.31 165.19 107.99 165.28 75.72 55.01 76.03 54.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "108.1 165.25 107.78 165.34 75.51 55.07 75.82 54.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "107.89 165.31 107.58 165.41 75.3 55.13 75.61 55.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "107.68 165.37 107.37 165.47 75.09 55.19 75.41 55.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "107.47 165.44 107.16 165.53 74.88 55.25 75.2 55.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "107.26 165.5 106.95 165.59 74.68 55.31 74.99 55.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "107.06 165.56 106.74 165.65 74.47 55.37 74.78 55.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "106.85 165.62 106.53 165.71 74.26 55.43 74.57 55.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "106.64 165.68 106.33 165.77 74.05 55.49 74.36 55.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st10",
    points: "106.43 165.74 105.48 166.02 73.2 55.74 74.15 55.46"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M84.66,84.36l23.83-2.8,13.65,43.57-20.64,11.01c-4.64-7.44-8.77-16.39-11.86-26.27-2.79-8.93-4.43-17.61-4.98-25.5"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st16"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "81.94 85.21 81.99 85.2 98.21 137.16 98.16 137.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "81.96 85.2 82.05 85.18 98.27 137.14 98.18 137.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "82.02 85.19 82.11 85.16 98.33 137.12 98.24 137.15"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "82.08 85.17 82.17 85.14 98.39 137.1 98.3 137.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "82.14 85.15 82.22 85.12 98.44 137.08 98.36 137.11"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "82.2 85.13 82.28 85.1 98.5 137.06 98.41 137.09"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "82.25 85.11 82.34 85.08 98.56 137.04 98.47 137.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "82.31 85.09 82.4 85.07 98.62 137.03 98.53 137.05"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "82.37 85.08 82.46 85.05 98.68 137.01 98.59 137.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "82.43 85.06 82.52 85.03 98.74 136.99 98.65 137.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "82.49 85.04 82.58 85.01 98.8 136.97 98.71 137"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "82.55 85.02 82.64 84.99 98.86 136.95 98.77 136.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "82.61 85 82.7 84.97 98.92 136.93 98.83 136.96"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "82.67 84.98 82.76 84.96 98.98 136.91 98.89 136.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "82.73 84.96 82.82 84.94 99.04 136.9 98.95 136.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "82.79 84.95 82.88 84.92 99.1 136.88 99.01 136.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "82.85 84.93 82.94 84.9 99.15 136.86 99.07 136.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "82.91 84.91 82.99 84.88 99.21 136.84 99.13 136.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "82.96 84.89 83.05 84.86 99.27 136.82 99.18 136.85"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "83.02 84.87 83.11 84.84 99.33 136.8 99.24 136.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "83.08 84.85 83.17 84.83 99.39 136.79 99.3 136.81"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "83.14 84.83 83.23 84.81 99.45 136.77 99.36 136.79"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "83.2 84.82 83.29 84.79 99.51 136.75 99.42 136.78"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "83.26 84.8 83.35 84.77 99.57 136.73 99.48 136.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "83.32 84.78 83.41 84.75 99.63 136.71 99.54 136.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "83.38 84.76 83.47 84.73 99.69 136.69 99.6 136.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "83.44 84.74 83.53 84.71 99.75 136.67 99.66 136.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "83.5 84.72 83.59 84.7 99.81 136.66 99.72 136.68"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "83.56 84.71 83.65 84.68 99.87 136.64 99.78 136.67"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "83.62 84.69 83.7 84.66 99.92 136.62 99.84 136.65"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "83.68 84.67 83.76 84.64 99.98 136.6 99.89 136.63"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "83.73 84.65 83.82 84.62 100.04 136.58 99.95 136.61"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "83.79 84.63 83.88 84.6 100.1 136.56 100.01 136.59"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "83.85 84.61 83.94 84.59 100.16 136.55 100.07 136.57"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "83.91 84.6 84 84.57 100.22 136.53 100.13 136.55"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "83.97 84.58 84.06 84.55 100.28 136.51 100.19 136.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "84.03 84.56 84.12 84.53 100.34 136.49 100.25 136.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "84.09 84.54 84.18 84.51 100.4 136.47 100.31 136.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "84.15 84.52 84.24 84.49 100.46 136.45 100.37 136.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "84.21 84.5 84.3 84.47 100.52 136.43 100.43 136.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "84.27 84.48 84.36 84.46 100.57 136.42 100.49 136.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "84.33 84.47 84.41 84.44 100.63 136.4 100.55 136.43"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "84.39 84.45 84.47 84.42 100.69 136.38 100.6 136.41"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "84.44 84.43 84.53 84.4 100.75 136.36 100.66 136.39"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "84.5 84.41 84.59 84.38 100.81 136.34 100.72 136.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "84.56 84.39 84.65 84.36 100.87 136.32 100.78 136.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "84.62 84.37 84.71 84.35 100.93 136.31 100.84 136.33"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "84.68 84.35 84.77 84.33 100.99 136.29 100.9 136.31"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "84.74 84.34 84.83 84.31 101.05 136.27 100.96 136.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "84.8 84.32 84.89 84.29 101.11 136.25 101.02 136.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "84.86 84.3 84.95 84.27 101.17 136.23 101.08 136.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "84.92 84.28 85.01 84.25 101.23 136.21 101.14 136.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "84.98 84.26 85.07 84.23 101.29 136.19 101.2 136.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "85.04 84.24 85.13 84.22 101.34 136.18 101.26 136.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "85.1 84.23 85.18 84.2 101.4 136.16 101.31 136.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "85.15 84.21 85.24 84.18 101.46 136.14 101.37 136.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "85.21 84.19 85.3 84.16 101.52 136.12 101.43 136.15"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "85.27 84.17 85.36 84.14 101.58 136.1 101.49 136.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "85.33 84.15 85.42 84.12 101.64 136.08 101.55 136.11"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "85.39 84.13 85.48 84.11 101.7 136.07 101.61 136.09"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "85.45 84.11 85.54 84.09 101.76 136.05 101.67 136.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "85.51 84.1 85.6 84.07 101.82 136.03 101.73 136.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "85.57 84.08 85.66 84.05 101.88 136.01 101.79 136.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "85.63 84.06 85.72 84.03 101.94 135.99 101.85 136.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "85.69 84.04 85.78 84.01 102 135.97 101.91 136"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "85.75 84.02 85.84 83.99 102.05 135.96 101.97 135.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "85.81 84 85.89 83.98 102.11 135.94 102.03 135.96"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "85.87 83.99 85.95 83.96 102.17 135.92 102.08 135.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "85.92 83.97 86.01 83.94 102.23 135.9 102.14 135.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "85.98 83.95 86.07 83.92 102.29 135.88 102.2 135.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "86.04 83.93 86.13 83.9 102.35 135.86 102.26 135.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "86.1 83.91 86.19 83.88 102.41 135.84 102.32 135.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "86.16 83.89 86.25 83.87 102.47 135.83 102.38 135.85"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "86.22 83.87 86.31 83.85 102.53 135.81 102.44 135.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "86.28 83.86 86.37 83.83 102.59 135.79 102.5 135.82"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "86.34 83.84 86.43 83.81 102.65 135.77 102.56 135.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "86.4 83.82 86.49 83.79 102.71 135.75 102.62 135.78"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "86.46 83.8 86.55 83.77 102.76 135.73 102.68 135.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "86.52 83.78 86.6 83.75 102.82 135.71 102.74 135.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "86.58 83.76 86.66 83.74 102.88 135.7 102.79 135.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "86.63 83.75 86.72 83.72 102.94 135.68 102.85 135.71"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "86.69 83.73 86.78 83.7 103 135.66 102.91 135.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "86.75 83.71 86.84 83.68 103.06 135.64 102.97 135.67"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "86.81 83.69 86.9 83.66 103.12 135.62 103.03 135.65"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "86.87 83.67 86.96 83.64 103.18 135.6 103.09 135.63"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "86.93 83.65 87.02 83.62 103.24 135.58 103.15 135.61"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "86.99 83.63 87.08 83.61 103.3 135.57 103.21 135.59"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "87.05 83.62 87.14 83.59 103.36 135.55 103.27 135.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "87.11 83.6 87.2 83.57 103.42 135.53 103.33 135.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "87.17 83.58 87.26 83.55 103.47 135.51 103.39 135.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "87.23 83.56 87.31 83.53 103.53 135.49 103.45 135.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "87.29 83.54 87.37 83.51 103.59 135.47 103.5 135.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "87.34 83.52 87.43 83.5 103.65 135.46 103.56 135.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "87.4 83.5 87.49 83.48 103.71 135.44 103.62 135.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "87.46 83.49 87.55 83.46 103.77 135.42 103.68 135.45"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "87.52 83.47 87.61 83.44 103.83 135.4 103.74 135.43"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "87.58 83.45 87.67 83.42 103.89 135.38 103.8 135.41"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "87.64 83.43 87.73 83.4 103.95 135.36 103.86 135.39"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "87.7 83.41 87.79 83.38 104.01 135.34 103.92 135.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "87.76 83.39 87.85 83.37 104.07 135.33 103.98 135.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "87.82 83.38 87.91 83.35 104.13 135.31 104.04 135.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "87.88 83.36 87.97 83.33 104.19 135.29 104.1 135.32"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "87.94 83.34 88.03 83.31 104.24 135.27 104.16 135.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "88 83.32 88.08 83.29 104.3 135.25 104.22 135.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "88.05 83.3 88.14 83.27 104.36 135.23 104.27 135.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "88.11 83.28 88.2 83.26 104.42 135.22 104.33 135.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "88.17 83.26 88.26 83.24 104.48 135.2 104.39 135.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "88.23 83.25 88.32 83.22 104.54 135.18 104.45 135.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "88.29 83.23 88.38 83.2 104.6 135.16 104.51 135.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "88.35 83.21 88.44 83.18 104.66 135.14 104.57 135.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "88.41 83.19 88.5 83.16 104.72 135.12 104.63 135.15"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "88.47 83.17 88.56 83.14 104.78 135.1 104.69 135.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "88.53 83.15 88.62 83.13 104.84 135.09 104.75 135.11"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "88.59 83.14 88.68 83.11 104.9 135.07 104.81 135.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "88.65 83.12 88.74 83.09 104.95 135.05 104.87 135.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "88.71 83.1 88.79 83.07 105.01 135.03 104.93 135.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "88.76 83.08 88.85 83.05 105.07 135.01 104.98 135.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "88.82 83.06 88.91 83.03 105.13 134.99 105.04 135.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "88.88 83.04 88.97 83.02 105.19 134.98 105.1 135"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "88.94 83.02 89.03 83 105.25 134.96 105.16 134.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "89 83.01 89.09 82.98 105.31 134.94 105.22 134.97"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "89.06 82.99 89.15 82.96 105.37 134.92 105.28 134.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "89.12 82.97 89.21 82.94 105.43 134.9 105.34 134.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "89.18 82.95 89.27 82.92 105.49 134.88 105.4 134.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "89.24 82.93 89.33 82.9 105.55 134.86 105.46 134.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "89.3 82.91 89.39 82.89 105.61 134.85 105.52 134.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "89.36 82.9 89.45 82.87 105.66 134.83 105.58 134.86"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "89.42 82.88 89.5 82.85 105.72 134.81 105.64 134.84"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "89.47 82.86 89.56 82.83 105.78 134.79 105.69 134.82"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "89.53 82.84 89.62 82.81 105.84 134.77 105.75 134.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "89.59 82.82 89.68 82.79 105.9 134.75 105.81 134.78"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "89.65 82.8 89.74 82.78 105.96 134.74 105.87 134.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "89.71 82.78 89.8 82.76 106.02 134.72 105.93 134.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "89.77 82.77 89.86 82.74 106.08 134.7 105.99 134.73"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "89.83 82.75 89.92 82.72 106.14 134.68 106.05 134.71"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "89.89 82.73 89.98 82.7 106.2 134.66 106.11 134.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "89.95 82.71 90.04 82.68 106.26 134.64 106.17 134.67"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "90.01 82.69 90.1 82.66 106.32 134.62 106.23 134.65"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "90.07 82.67 90.16 82.65 106.38 134.61 106.29 134.63"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "90.13 82.65 90.21 82.63 106.43 134.59 106.35 134.62"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "90.19 82.64 90.27 82.61 106.49 134.57 106.4 134.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "90.24 82.62 90.33 82.59 106.55 134.55 106.46 134.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "90.3 82.6 90.39 82.57 106.61 134.53 106.52 134.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "90.36 82.58 90.45 82.55 106.67 134.51 106.58 134.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "90.42 82.56 90.51 82.54 106.73 134.5 106.64 134.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "90.48 82.54 90.57 82.52 106.79 134.48 106.7 134.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "90.54 82.53 90.63 82.5 106.85 134.46 106.76 134.49"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "90.6 82.51 90.69 82.48 106.91 134.44 106.82 134.47"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "90.66 82.49 90.75 82.46 106.97 134.42 106.88 134.45"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "90.72 82.47 90.81 82.44 107.03 134.4 106.94 134.43"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "90.78 82.45 90.87 82.42 107.09 134.38 107 134.41"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "90.84 82.43 90.93 82.41 107.14 134.37 107.06 134.39"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "90.9 82.41 90.98 82.39 107.2 134.35 107.12 134.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "90.95 82.4 91.04 82.37 107.26 134.33 107.17 134.36"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "91.01 82.38 91.1 82.35 107.32 134.31 107.23 134.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "91.07 82.36 91.16 82.33 107.38 134.29 107.29 134.32"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "91.13 82.34 91.22 82.31 107.44 134.27 107.35 134.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "91.19 82.32 91.28 82.29 107.5 134.25 107.41 134.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "91.25 82.3 91.34 82.28 107.56 134.24 107.47 134.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "91.31 82.29 91.4 82.26 107.62 134.22 107.53 134.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "91.37 82.27 91.46 82.24 107.68 134.2 107.59 134.23"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "91.43 82.25 91.52 82.22 107.74 134.18 107.65 134.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "91.49 82.23 91.58 82.2 107.8 134.16 107.71 134.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "91.55 82.21 91.64 82.18 107.85 134.14 107.77 134.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "91.61 82.19 91.69 82.17 107.91 134.13 107.82 134.15"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "91.66 82.17 91.75 82.15 107.97 134.11 107.88 134.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "91.72 82.16 91.81 82.13 108.03 134.09 107.94 134.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "91.78 82.14 91.87 82.11 108.09 134.07 108 134.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "91.84 82.12 91.93 82.09 108.15 134.05 108.06 134.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "91.9 82.1 91.99 82.07 108.21 134.03 108.12 134.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "91.96 82.08 92.05 82.05 108.27 134.01 108.18 134.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "92.02 82.06 92.11 82.04 108.33 134 108.24 134.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "92.08 82.05 92.17 82.02 108.39 133.98 108.3 134.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "92.14 82.03 92.23 82 108.45 133.96 108.36 133.99"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "92.2 82.01 92.29 81.98 108.51 133.94 108.42 133.97"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "92.26 81.99 92.35 81.96 108.56 133.92 108.48 133.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "92.32 81.97 92.4 81.94 108.62 133.9 108.54 133.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "92.38 81.95 92.46 81.93 108.68 133.89 108.59 133.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "92.43 81.93 92.52 81.91 108.74 133.87 108.65 133.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "92.49 81.92 92.58 81.89 108.8 133.85 108.71 133.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "92.55 81.9 92.64 81.87 108.86 133.83 108.77 133.86"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "92.61 81.88 92.7 81.85 108.92 133.81 108.83 133.84"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "92.67 81.86 92.76 81.83 108.98 133.79 108.89 133.82"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "92.73 81.84 92.82 81.81 109.04 133.77 108.95 133.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "92.79 81.82 92.88 81.8 109.1 133.76 109.01 133.78"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "92.85 81.81 92.94 81.78 109.16 133.74 109.07 133.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "92.91 81.79 93 81.76 109.22 133.72 109.13 133.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "92.97 81.77 93.06 81.74 109.28 133.7 109.19 133.73"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "93.03 81.75 93.12 81.72 109.33 133.68 109.25 133.71"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "93.09 81.73 93.17 81.7 109.39 133.66 109.3 133.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "93.14 81.71 93.23 81.69 109.45 133.65 109.36 133.67"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "93.2 81.69 93.29 81.67 109.51 133.63 109.42 133.65"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "93.26 81.68 93.35 81.65 109.57 133.61 109.48 133.64"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "93.32 81.66 93.41 81.63 109.63 133.59 109.54 133.62"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "93.38 81.64 93.47 81.61 109.69 133.57 109.6 133.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "93.44 81.62 93.53 81.59 109.75 133.55 109.66 133.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "93.5 81.6 93.59 81.57 109.81 133.53 109.72 133.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "93.56 81.58 93.65 81.56 109.87 133.52 109.78 133.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "93.62 81.56 93.71 81.54 109.93 133.5 109.84 133.53"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "93.68 81.55 93.77 81.52 109.99 133.48 109.9 133.51"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "93.74 81.53 93.82 81.5 110.04 133.46 109.96 133.49"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "93.8 81.51 93.88 81.48 110.1 133.44 110.01 133.47"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "93.85 81.49 93.94 81.46 110.16 133.42 110.07 133.45"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "93.91 81.47 94 81.45 110.22 133.41 110.13 133.43"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "93.97 81.45 94.06 81.43 110.28 133.39 110.19 133.41"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "94.03 81.44 94.12 81.41 110.34 133.37 110.25 133.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "94.09 81.42 94.18 81.39 110.4 133.35 110.31 133.38"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "94.15 81.4 94.24 81.37 110.46 133.33 110.37 133.36"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "94.21 81.38 94.3 81.35 110.52 133.31 110.43 133.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "94.27 81.36 94.36 81.33 110.58 133.29 110.49 133.32"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "94.33 81.34 94.42 81.32 110.64 133.28 110.55 133.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "94.39 81.33 94.48 81.3 110.7 133.26 110.61 133.29"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "94.45 81.31 94.54 81.28 110.75 133.24 110.67 133.27"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "94.51 81.29 94.59 81.26 110.81 133.22 110.73 133.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "94.56 81.27 94.65 81.24 110.87 133.2 110.78 133.23"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "94.62 81.25 94.71 81.22 110.93 133.18 110.84 133.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "94.68 81.23 94.77 81.2 110.99 133.16 110.9 133.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "94.74 81.21 94.83 81.19 111.05 133.15 110.96 133.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "94.8 81.2 94.89 81.17 111.11 133.13 111.02 133.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "94.86 81.18 94.95 81.15 111.17 133.11 111.08 133.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "94.92 81.16 95.01 81.13 111.23 133.09 111.14 133.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "94.98 81.14 95.07 81.11 111.29 133.07 111.2 133.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "95.04 81.12 95.13 81.09 111.35 133.05 111.26 133.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "95.1 81.1 95.19 81.08 111.41 133.04 111.32 133.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "95.16 81.08 95.25 81.06 111.47 133.02 111.38 133.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "95.22 81.07 95.3 81.04 111.52 133 111.44 133.03"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "95.28 81.05 95.36 81.02 111.58 132.98 111.49 133.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "95.33 81.03 95.42 81 111.64 132.96 111.55 132.99"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "95.39 81.01 95.48 80.98 111.7 132.94 111.61 132.97"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "95.45 80.99 95.54 80.96 111.76 132.92 111.67 132.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "95.51 80.97 95.6 80.95 111.82 132.91 111.73 132.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "95.57 80.96 95.66 80.93 111.88 132.89 111.79 132.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "95.63 80.94 95.72 80.91 111.94 132.87 111.85 132.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "95.69 80.92 95.78 80.89 112 132.85 111.91 132.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "95.75 80.9 95.84 80.87 112.06 132.83 111.97 132.86"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "95.81 80.88 95.9 80.85 112.12 132.81 112.03 132.84"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "95.87 80.86 95.96 80.84 112.18 132.79 112.09 132.82"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "95.93 80.84 96.01 80.82 112.23 132.78 112.15 132.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "95.99 80.83 96.07 80.8 112.29 132.76 112.2 132.79"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "96.04 80.81 96.13 80.78 112.35 132.74 112.26 132.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "96.1 80.79 96.19 80.76 112.41 132.72 112.32 132.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "96.16 80.77 96.25 80.74 112.47 132.7 112.38 132.73"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "96.22 80.75 96.31 80.72 112.53 132.68 112.44 132.71"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "96.28 80.73 96.37 80.71 112.59 132.67 112.5 132.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "96.34 80.72 96.43 80.69 112.65 132.65 112.56 132.67"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "96.4 80.7 96.49 80.67 112.71 132.63 112.62 132.66"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "96.46 80.68 96.55 80.65 112.77 132.61 112.68 132.64"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "96.52 80.66 96.61 80.63 112.83 132.59 112.74 132.62"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "96.58 80.64 96.67 80.61 112.89 132.57 112.8 132.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "96.64 80.62 96.73 80.6 112.94 132.56 112.86 132.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "96.7 80.6 96.78 80.58 113 132.54 112.91 132.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "96.75 80.59 96.84 80.56 113.06 132.52 112.97 132.55"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "96.81 80.57 96.9 80.54 113.12 132.5 113.03 132.53"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "96.87 80.55 96.96 80.52 113.18 132.48 113.09 132.51"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "96.93 80.53 97.02 80.5 113.24 132.46 113.15 132.49"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "96.99 80.51 107.22 77.32 123.43 129.28 113.21 132.47"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M131.93,157.76c4.86-1.24,8.48-5.35,10.74-11.45l-36.13-2.95c8.34,10.65,17.63,16.39,25.4,14.41"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "143.77 157.88 143.73 157.89 142.02 139.98 142.07 139.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "143.79 157.88 143.59 157.9 141.89 140 142.09 139.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "143.66 157.89 143.46 157.91 141.75 140.01 141.96 139.99"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "143.52 157.91 143.32 157.92 141.62 140.02 141.82 140"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "143.39 157.92 143.18 157.94 141.48 140.03 141.69 140.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "143.25 157.93 143.05 157.95 141.35 140.05 141.55 140.03"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "143.12 157.94 142.91 157.96 141.21 140.06 141.42 140.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "142.98 157.96 142.78 157.98 141.08 140.07 141.28 140.05"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "142.85 157.97 142.64 157.99 140.94 140.09 141.15 140.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "142.71 157.98 142.51 158 140.81 140.1 141.01 140.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "142.58 158 142.37 158.01 140.67 140.11 140.87 140.09"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "142.44 158.01 142.24 158.03 140.54 140.12 140.74 140.11"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "142.3 158.02 142.1 158.04 140.4 140.14 140.6 140.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "142.17 158.03 141.97 158.05 140.27 140.15 140.47 140.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "142.03 158.05 141.83 158.07 140.13 140.16 140.33 140.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "141.9 158.06 141.7 158.08 140 140.18 140.2 140.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "141.76 158.07 141.56 158.09 139.86 140.19 140.06 140.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "141.63 158.09 141.43 158.1 139.72 140.2 139.93 140.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "141.49 158.1 141.29 158.12 139.59 140.21 139.79 140.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "141.36 158.11 141.16 158.13 139.45 140.23 139.66 140.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "141.22 158.12 141.02 158.14 139.32 140.24 139.52 140.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "141.09 158.14 140.88 158.16 139.18 140.25 139.39 140.23"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "140.95 158.15 140.75 158.17 139.05 140.27 139.25 140.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "140.82 158.16 140.61 158.18 138.91 140.28 139.12 140.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "140.68 158.18 140.48 158.19 138.78 140.29 138.98 140.27"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "140.55 158.19 140.34 158.21 138.64 140.3 138.85 140.29"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "140.41 158.2 140.21 158.22 138.51 140.32 138.71 140.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "140.28 158.21 140.07 158.23 138.37 140.33 138.57 140.31"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "140.14 158.23 139.94 158.25 138.24 140.34 138.44 140.32"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "140.01 158.24 139.8 158.26 138.1 140.36 138.3 140.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "139.87 158.25 139.67 158.27 137.97 140.37 138.17 140.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "139.73 158.27 139.53 158.29 137.83 140.38 138.03 140.36"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "139.6 158.28 139.4 158.3 137.7 140.39 137.9 140.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "139.46 158.29 139.26 158.31 137.56 140.41 137.76 140.39"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "139.33 158.3 139.13 158.32 137.42 140.42 137.63 140.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "139.19 158.32 138.99 158.34 137.29 140.43 137.49 140.41"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "139.06 158.33 138.86 158.35 137.15 140.45 137.36 140.43"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "138.92 158.34 138.72 158.36 137.02 140.46 137.22 140.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "138.79 158.36 138.58 158.37 136.88 140.47 137.09 140.45"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "138.65 158.37 138.45 158.39 136.75 140.48 136.95 140.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "138.52 158.38 138.31 158.4 136.61 140.5 136.82 140.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "138.38 158.39 138.18 158.41 136.48 140.51 136.68 140.49"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "138.25 158.41 138.04 158.43 136.34 140.52 136.55 140.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "138.11 158.42 137.91 158.44 136.21 140.54 136.41 140.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "137.98 158.43 137.77 158.45 136.07 140.55 136.27 140.53"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "137.84 158.45 137.64 158.46 135.94 140.56 136.14 140.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "137.71 158.46 137.5 158.48 135.8 140.57 136 140.55"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "137.57 158.47 137.37 158.49 135.67 140.59 135.87 140.57"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "137.43 158.48 137.23 158.5 135.53 140.6 135.73 140.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "137.3 158.5 137.1 158.52 135.4 140.61 135.6 140.59"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "137.16 158.51 136.96 158.53 135.26 140.63 135.46 140.61"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "137.03 158.52 136.83 158.54 135.12 140.64 135.33 140.62"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "136.89 158.54 136.69 158.55 134.99 140.65 135.19 140.63"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "136.76 158.55 136.56 158.57 134.85 140.66 135.06 140.64"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "136.62 158.56 136.42 158.58 134.72 140.68 134.92 140.66"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "136.49 158.57 136.28 158.59 134.58 140.69 134.79 140.67"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "136.35 158.59 136.15 158.61 134.45 140.7 134.65 140.68"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "136.22 158.6 136.01 158.62 134.31 140.72 134.52 140.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "136.08 158.61 135.88 158.63 134.18 140.73 134.38 140.71"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "135.95 158.62 135.74 158.64 134.04 140.74 134.25 140.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "135.81 158.64 135.61 158.66 133.91 140.75 134.11 140.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "135.68 158.65 135.47 158.67 133.77 140.77 133.97 140.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "135.54 158.66 135.34 158.68 133.64 140.78 133.84 140.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "135.41 158.68 135.2 158.7 133.5 140.79 133.7 140.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "135.27 158.69 135.07 158.71 133.37 140.81 133.57 140.79"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "135.13 158.7 134.93 158.72 133.23 140.82 133.43 140.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "135 158.71 134.8 158.73 133.1 140.83 133.3 140.81"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "134.86 158.73 134.66 158.75 132.96 140.84 133.16 140.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "134.73 158.74 134.53 158.76 132.82 140.86 133.03 140.84"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "134.59 158.75 134.39 158.77 132.69 140.87 132.89 140.85"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "134.46 158.77 134.26 158.79 132.55 140.88 132.76 140.86"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "134.32 158.78 134.12 158.8 132.42 140.9 132.62 140.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "134.19 158.79 133.98 158.81 132.28 140.91 132.49 140.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "134.05 158.81 133.85 158.82 132.15 140.92 132.35 140.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "133.92 158.82 133.71 158.84 132.01 140.93 132.22 140.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "133.78 158.83 133.58 158.85 131.88 140.95 132.08 140.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "133.65 158.84 133.44 158.86 131.74 140.96 131.95 140.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "133.51 158.86 133.31 158.88 131.61 140.97 131.81 140.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "133.38 158.87 133.17 158.89 131.47 140.99 131.68 140.97"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "133.24 158.88 133.04 158.9 131.34 141 131.54 140.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "133.11 158.9 132.9 158.91 131.2 141.01 131.4 140.99"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "132.97 158.91 132.77 158.93 131.07 141.02 131.27 141"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "132.83 158.92 132.63 158.94 130.93 141.04 131.13 141.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "132.7 158.93 132.5 158.95 130.8 141.05 131 141.03"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "132.56 158.95 132.36 158.97 130.66 141.06 130.86 141.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "132.43 158.96 132.23 158.98 130.53 141.08 130.73 141.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "132.29 158.97 132.09 158.99 130.39 141.09 130.59 141.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "132.16 158.99 131.96 159 130.25 141.1 130.46 141.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "132.02 159 131.82 159.02 130.12 141.11 130.32 141.09"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "131.89 159.01 131.68 159.03 129.98 141.13 130.19 141.11"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "131.75 159.02 131.55 159.04 129.85 141.14 130.05 141.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "131.62 159.04 131.41 159.06 129.71 141.15 129.92 141.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "131.48 159.05 131.28 159.07 129.58 141.16 129.78 141.15"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "131.35 159.06 131.14 159.08 129.44 141.18 129.65 141.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "131.21 159.08 131.01 159.09 129.31 141.19 129.51 141.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "131.08 159.09 130.87 159.11 129.17 141.2 129.37 141.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "130.94 159.1 130.74 159.12 129.04 141.22 129.24 141.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "130.81 159.11 130.6 159.13 128.9 141.23 129.1 141.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "130.67 159.13 130.47 159.15 128.77 141.24 128.97 141.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "130.53 159.14 130.33 159.16 128.63 141.26 128.83 141.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "130.4 159.15 130.2 159.17 128.5 141.27 128.7 141.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "130.26 159.16 130.06 159.18 128.36 141.28 128.56 141.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "130.13 159.18 129.93 159.2 128.22 141.29 128.43 141.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "129.99 159.19 129.79 159.21 128.09 141.31 128.29 141.29"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "129.86 159.2 129.66 159.22 127.95 141.32 128.16 141.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "129.72 159.22 129.52 159.24 127.82 141.33 128.02 141.31"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "129.59 159.23 129.39 159.25 127.68 141.35 127.89 141.33"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "129.45 159.24 129.25 159.26 127.55 141.36 127.75 141.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "129.32 159.25 129.11 159.27 127.41 141.37 127.62 141.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "129.18 159.27 128.98 159.29 127.28 141.38 127.48 141.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "129.05 159.28 128.84 159.3 127.14 141.4 127.35 141.38"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "128.91 159.29 128.71 159.31 127.01 141.41 127.21 141.39"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "128.78 159.31 128.57 159.33 126.87 141.42 127.07 141.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "128.64 159.32 128.44 159.34 126.74 141.44 126.94 141.42"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "128.51 159.33 128.3 159.35 126.6 141.45 126.8 141.43"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "128.37 159.34 128.17 159.36 126.47 141.46 126.67 141.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "128.23 159.36 128.03 159.38 126.33 141.47 126.53 141.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "128.1 159.37 127.9 159.39 126.2 141.49 126.4 141.47"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "127.96 159.38 127.76 159.4 126.06 141.5 126.26 141.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "127.83 159.4 127.63 159.42 125.93 141.51 126.13 141.49"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "127.69 159.41 127.49 159.43 125.79 141.53 125.99 141.51"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "127.56 159.42 127.36 159.44 125.65 141.54 125.86 141.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "127.42 159.44 127.22 159.45 125.52 141.55 125.72 141.53"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "127.29 159.45 127.08 159.47 125.38 141.56 125.59 141.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "127.15 159.46 126.95 159.48 125.25 141.58 125.45 141.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "127.02 159.47 126.81 159.49 125.11 141.59 125.32 141.57"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "126.88 159.49 126.68 159.51 124.98 141.6 125.18 141.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "126.75 159.5 126.54 159.52 124.84 141.62 125.05 141.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "126.61 159.51 126.41 159.53 124.71 141.63 124.91 141.61"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "126.48 159.53 126.27 159.54 124.57 141.64 124.77 141.62"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "126.34 159.54 126.14 159.56 124.44 141.65 124.64 141.63"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "126.21 159.55 126 159.57 124.3 141.67 124.5 141.65"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "126.07 159.56 125.87 159.58 124.17 141.68 124.37 141.66"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "125.93 159.58 125.73 159.6 124.03 141.69 124.23 141.67"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "125.8 159.59 125.6 159.61 123.9 141.71 124.1 141.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "125.66 159.6 125.46 159.62 123.76 141.72 123.96 141.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "125.53 159.62 125.33 159.63 123.62 141.73 123.83 141.71"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "125.39 159.63 125.19 159.65 123.49 141.74 123.69 141.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "125.26 159.64 125.06 159.66 123.35 141.76 123.56 141.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "125.12 159.65 124.92 159.67 123.22 141.77 123.42 141.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "124.99 159.67 124.78 159.69 123.08 141.78 123.29 141.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "124.85 159.68 124.65 159.7 122.95 141.79 123.15 141.78"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "124.72 159.69 124.51 159.71 122.81 141.81 123.02 141.79"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "124.58 159.71 124.38 159.72 122.68 141.82 122.88 141.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "124.45 159.72 124.24 159.74 122.54 141.83 122.75 141.81"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "124.31 159.73 124.11 159.75 122.41 141.85 122.61 141.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "124.18 159.74 123.97 159.76 122.27 141.86 122.47 141.84"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "124.04 159.76 123.84 159.78 122.14 141.87 122.34 141.85"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "123.91 159.77 123.7 159.79 122 141.89 122.2 141.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "123.77 159.78 123.57 159.8 121.87 141.9 122.07 141.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "123.63 159.79 123.43 159.81 121.73 141.91 121.93 141.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "123.5 159.81 123.3 159.83 121.6 141.92 121.8 141.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "123.36 159.82 123.16 159.84 121.46 141.94 121.66 141.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "123.23 159.83 123.03 159.85 121.32 141.95 121.53 141.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "123.09 159.85 122.89 159.87 121.19 141.96 121.39 141.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "122.96 159.86 122.76 159.88 121.05 141.98 121.26 141.96"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "122.82 159.87 122.62 159.89 120.92 141.99 121.12 141.97"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "122.69 159.88 122.48 159.9 120.78 142 120.99 141.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "122.55 159.9 122.35 159.92 120.65 142.01 120.85 141.99"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "122.42 159.91 122.21 159.93 120.51 142.03 120.72 142.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "122.28 159.92 122.08 159.94 120.38 142.04 120.58 142.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "122.15 159.94 121.94 159.96 120.24 142.05 120.45 142.03"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "122.01 159.95 121.81 159.97 120.11 142.07 120.31 142.05"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "121.88 159.96 121.67 159.98 119.97 142.08 120.18 142.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "121.74 159.97 121.54 159.99 119.84 142.09 120.04 142.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "121.61 159.99 121.4 160.01 119.7 142.1 119.9 142.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "121.47 160 121.27 160.02 119.57 142.12 119.77 142.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "121.33 160.01 121.13 160.03 119.43 142.13 119.63 142.11"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "121.2 160.03 121 160.05 119.3 142.14 119.5 142.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "121.06 160.04 120.86 160.06 119.16 142.16 119.36 142.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "120.93 160.05 120.73 160.07 119.03 142.17 119.23 142.15"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "120.79 160.06 120.59 160.08 118.89 142.18 119.09 142.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "120.66 160.08 120.46 160.1 118.75 142.19 118.96 142.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "120.52 160.09 120.32 160.11 118.62 142.21 118.82 142.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "120.39 160.1 120.18 160.12 118.48 142.22 118.69 142.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "120.25 160.12 120.05 160.14 118.35 142.23 118.55 142.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "120.12 160.13 119.91 160.15 118.21 142.25 118.42 142.23"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "119.98 160.14 119.78 160.16 118.08 142.26 118.28 142.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "119.85 160.16 119.64 160.17 117.94 142.27 118.15 142.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "119.71 160.17 119.51 160.19 117.81 142.28 118.01 142.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "119.58 160.18 119.37 160.2 117.67 142.3 117.88 142.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "119.44 160.19 119.24 160.21 117.54 142.31 117.74 142.29"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "119.31 160.21 119.1 160.23 117.4 142.32 117.6 142.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "119.17 160.22 118.97 160.24 117.27 142.33 117.47 142.32"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "119.03 160.23 118.83 160.25 117.13 142.35 117.33 142.33"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "118.9 160.25 118.7 160.26 117 142.36 117.2 142.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "118.76 160.26 118.56 160.28 116.86 142.37 117.06 142.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "118.63 160.27 118.43 160.29 116.72 142.39 116.93 142.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "118.49 160.28 118.29 160.3 116.59 142.4 116.79 142.38"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "118.36 160.3 118.16 160.32 116.45 142.41 116.66 142.39"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "118.22 160.31 118.02 160.33 116.32 142.42 116.52 142.41"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "118.09 160.32 117.88 160.34 116.18 142.44 116.39 142.42"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "117.95 160.33 117.75 160.35 116.05 142.45 116.25 142.43"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "117.82 160.35 117.61 160.37 115.91 142.46 116.12 142.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "117.68 160.36 117.48 160.38 115.78 142.48 115.98 142.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "117.55 160.37 117.34 160.39 115.64 142.49 115.85 142.47"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "117.41 160.39 117.21 160.41 115.51 142.5 115.71 142.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "117.28 160.4 117.07 160.42 115.37 142.52 115.57 142.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "117.14 160.41 116.94 160.43 115.24 142.53 115.44 142.51"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "117.01 160.42 116.8 160.44 115.1 142.54 115.3 142.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "116.87 160.44 116.67 160.46 114.97 142.55 115.17 142.53"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "116.73 160.45 116.53 160.47 114.83 142.57 115.03 142.55"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "116.6 160.46 116.4 160.48 114.7 142.58 114.9 142.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "116.46 160.48 116.26 160.5 114.56 142.59 114.76 142.57"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "116.33 160.49 116.13 160.51 114.43 142.61 114.63 142.59"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "116.19 160.5 115.99 160.52 114.29 142.62 114.49 142.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "116.06 160.51 115.86 160.53 114.15 142.63 114.36 142.61"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "115.92 160.53 115.72 160.55 114.02 142.64 114.22 142.62"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "115.79 160.54 115.58 160.56 113.88 142.66 114.09 142.64"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "115.65 160.55 115.45 160.57 113.75 142.67 113.95 142.65"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "115.52 160.57 115.31 160.59 113.61 142.68 113.82 142.66"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "115.38 160.58 115.18 160.6 113.48 142.7 113.68 142.68"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "115.25 160.59 115.04 160.61 113.34 142.71 113.55 142.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "115.11 160.6 114.91 160.62 113.21 142.72 113.41 142.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "114.98 160.62 114.77 160.64 113.07 142.73 113.28 142.71"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "114.84 160.63 114.64 160.65 112.94 142.75 113.14 142.73"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "114.71 160.64 114.5 160.66 112.8 142.76 113 142.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "114.57 160.66 114.37 160.68 112.67 142.77 112.87 142.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "114.43 160.67 114.23 160.69 112.53 142.79 112.73 142.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "114.3 160.68 114.1 160.7 112.4 142.8 112.6 142.78"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "114.16 160.69 113.96 160.71 112.26 142.81 112.46 142.79"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "114.03 160.71 113.83 160.73 112.13 142.82 112.33 142.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "113.89 160.72 113.69 160.74 111.99 142.84 112.19 142.82"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "113.76 160.73 113.56 160.75 111.85 142.85 112.06 142.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "113.62 160.75 113.42 160.77 111.72 142.86 111.92 142.84"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "113.49 160.76 113.28 160.78 111.58 142.87 111.79 142.86"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "113.35 160.77 113.15 160.79 111.45 142.89 111.65 142.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "113.22 160.79 113.01 160.8 111.31 142.9 111.52 142.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "113.08 160.8 112.88 160.82 111.18 142.91 111.38 142.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "112.95 160.81 112.74 160.83 111.04 142.93 111.25 142.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "112.81 160.82 112.61 160.84 110.91 142.94 111.11 142.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "112.68 160.84 112.47 160.86 110.77 142.95 110.97 142.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "112.54 160.85 112.34 160.87 110.64 142.96 110.84 142.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "112.41 160.86 112.2 160.88 110.5 142.98 110.7 142.96"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "112.27 160.87 112.07 160.89 110.37 142.99 110.57 142.97"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "112.14 160.89 111.93 160.91 110.23 143 110.43 142.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "112 160.9 111.8 160.92 110.1 143.02 110.3 143"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "111.86 160.91 111.66 160.93 109.96 143.03 110.16 143.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "111.73 160.93 111.53 160.95 109.82 143.04 110.03 143.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "111.59 160.94 111.39 160.96 109.69 143.05 109.89 143.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "111.46 160.95 111.26 160.97 109.55 143.07 109.76 143.05"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "111.32 160.96 111.12 160.98 109.42 143.08 109.62 143.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "111.19 160.98 110.99 161 109.28 143.09 109.49 143.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "111.05 160.99 110.85 161.01 109.15 143.11 109.35 143.09"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "110.92 161 110.71 161.02 109.01 143.12 109.22 143.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "110.78 161.02 110.58 161.04 108.88 143.13 109.08 143.11"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "110.65 161.03 110.44 161.05 108.74 143.15 108.95 143.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "110.51 161.04 110.31 161.06 108.61 143.16 108.81 143.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "110.38 161.05 110.17 161.07 108.47 143.17 108.68 143.15"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "110.24 161.07 110.04 161.09 108.34 143.18 108.54 143.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "110.11 161.08 109.9 161.1 108.2 143.2 108.4 143.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "109.97 161.09 109.77 161.11 108.07 143.21 108.27 143.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st13",
    points: "109.83 161.11 108.24 161.26 106.54 143.35 108.13 143.2"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M84.73,72.16l22.87-22.08c-3.36-1.42-6.63-1.83-9.67-1.05-7.53,1.92-12.08,10.73-13.2,23.14"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.74 49.44 107.73 49.47 89.11 45.27 89.12 45.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.75 49.41 107.7 49.59 89.09 45.39 89.13 45.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.72 49.53 107.68 49.71 89.06 45.51 89.1 45.33"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.69 49.65 107.65 49.83 89.03 45.63 89.07 45.45"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.66 49.77 107.62 49.95 89 45.76 89.04 45.57"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.64 49.89 107.59 50.08 88.98 45.88 89.02 45.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.61 50.02 107.57 50.2 88.95 46 88.99 45.82"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.58 50.14 107.54 50.32 88.92 46.12 88.96 45.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.55 50.26 107.51 50.44 88.89 46.24 88.93 46.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.53 50.38 107.48 50.56 88.87 46.37 88.91 46.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.5 50.5 107.46 50.69 88.84 46.49 88.88 46.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.47 50.63 107.43 50.81 88.81 46.61 88.85 46.43"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.44 50.75 107.4 50.93 88.78 46.73 88.82 46.55"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.42 50.87 107.37 51.05 88.76 46.85 88.8 46.67"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.39 50.99 107.35 51.17 88.73 46.98 88.77 46.79"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.36 51.11 107.32 51.3 88.7 47.1 88.74 46.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.33 51.24 107.29 51.42 88.67 47.22 88.71 47.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.31 51.36 107.26 51.54 88.65 47.34 88.69 47.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.28 51.48 107.24 51.66 88.62 47.46 88.66 47.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.25 51.6 107.21 51.78 88.59 47.59 88.63 47.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.22 51.72 107.18 51.91 88.56 47.71 88.6 47.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.2 51.85 107.15 52.03 88.53 47.83 88.58 47.65"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.17 51.97 107.13 52.15 88.51 47.95 88.55 47.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.14 52.09 107.1 52.27 88.48 48.07 88.52 47.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.11 52.21 107.07 52.39 88.45 48.2 88.49 48.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.09 52.33 107.04 52.52 88.43 48.32 88.47 48.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.06 52.46 107.02 52.64 88.4 48.44 88.44 48.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.03 52.58 106.99 52.76 88.37 48.56 88.41 48.38"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107 52.7 106.96 52.88 88.34 48.68 88.38 48.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.98 52.82 106.93 53 88.31 48.81 88.36 48.62"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.95 52.94 106.91 53.13 88.29 48.93 88.33 48.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.92 53.07 106.88 53.25 88.26 49.05 88.3 48.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.89 53.19 106.85 53.37 88.23 49.17 88.27 48.99"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.87 53.31 106.82 53.49 88.2 49.29 88.25 49.11"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.84 53.43 106.8 53.62 88.18 49.42 88.22 49.23"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.81 53.55 106.77 53.74 88.15 49.54 88.19 49.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.78 53.68 106.74 53.86 88.12 49.66 88.16 49.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.76 53.8 106.71 53.98 88.09 49.78 88.14 49.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.73 53.92 106.69 54.1 88.07 49.9 88.11 49.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.7 54.04 106.66 54.23 88.04 50.03 88.08 49.84"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.67 54.16 106.63 54.35 88.01 50.15 88.05 49.97"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.65 54.29 106.6 54.47 87.98 50.27 88.03 50.09"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.62 54.41 106.58 54.59 87.96 50.39 88 50.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.59 54.53 106.55 54.71 87.93 50.51 87.97 50.33"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.56 54.65 106.52 54.84 87.9 50.64 87.94 50.45"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.53 54.77 106.49 54.96 87.87 50.76 87.92 50.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.51 54.9 106.47 55.08 87.85 50.88 87.89 50.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.48 55.02 106.44 55.2 87.82 51 87.86 50.82"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.45 55.14 106.41 55.32 87.79 51.12 87.83 50.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.43 55.26 106.38 55.45 87.76 51.25 87.81 51.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.4 55.38 106.36 55.57 87.74 51.37 87.78 51.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.37 55.51 106.33 55.69 87.71 51.49 87.75 51.31"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.34 55.63 106.3 55.81 87.68 51.61 87.72 51.43"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.31 55.75 106.27 55.93 87.65 51.73 87.7 51.55"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.29 55.87 106.25 56.06 87.63 51.86 87.67 51.67"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.26 55.99 106.22 56.18 87.6 51.98 87.64 51.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.23 56.12 106.19 56.3 87.57 52.1 87.61 51.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.2 56.24 106.16 56.42 87.54 52.22 87.59 52.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.18 56.36 106.14 56.54 87.52 52.34 87.56 52.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.15 56.48 106.11 56.67 87.49 52.47 87.53 52.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.12 56.6 106.08 56.79 87.46 52.59 87.5 52.41"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.09 56.73 106.05 56.91 87.43 52.71 87.48 52.53"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.07 56.85 106.03 57.03 87.41 52.83 87.45 52.65"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.04 56.97 106 57.15 87.38 52.96 87.42 52.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.01 57.09 105.97 57.28 87.35 53.08 87.39 52.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.98 57.21 105.94 57.4 87.32 53.2 87.37 53.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.96 57.34 105.92 57.52 87.3 53.32 87.34 53.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.93 57.46 105.89 57.64 87.27 53.44 87.31 53.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.9 57.58 105.86 57.76 87.24 53.56 87.28 53.38"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.87 57.7 105.83 57.89 87.21 53.69 87.26 53.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.85 57.83 105.81 58.01 87.19 53.81 87.23 53.63"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.82 57.95 105.78 58.13 87.16 53.93 87.2 53.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.79 58.07 105.75 58.25 87.13 54.05 87.17 53.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.76 58.19 105.72 58.37 87.1 54.18 87.15 53.99"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.74 58.31 105.7 58.5 87.08 54.3 87.12 54.11"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.71 58.44 105.67 58.62 87.05 54.42 87.09 54.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.68 58.56 105.64 58.74 87.02 54.54 87.06 54.36"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.65 58.68 105.61 58.86 86.99 54.66 87.04 54.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.63 58.8 105.59 58.98 86.97 54.79 87.01 54.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.6 58.92 105.56 59.11 86.94 54.91 86.98 54.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.57 59.05 105.53 59.23 86.91 55.03 86.95 54.85"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.54 59.17 105.5 59.35 86.88 55.15 86.93 54.97"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.52 59.29 105.48 59.47 86.86 55.27 86.9 55.09"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.49 59.41 105.45 59.59 86.83 55.4 86.87 55.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.46 59.53 105.42 59.72 86.8 55.52 86.84 55.33"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.43 59.66 105.39 59.84 86.77 55.64 86.82 55.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.41 59.78 105.37 59.96 86.75 55.76 86.79 55.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.38 59.9 105.34 60.08 86.72 55.88 86.76 55.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.35 60.02 105.31 60.2 86.69 56.01 86.73 55.82"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.32 60.14 105.28 60.33 86.66 56.13 86.7 55.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.3 60.27 105.26 60.45 86.64 56.25 86.68 56.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.27 60.39 105.23 60.57 86.61 56.37 86.65 56.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.24 60.51 105.2 60.69 86.58 56.49 86.62 56.31"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.21 60.63 105.17 60.81 86.55 56.62 86.59 56.43"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.19 60.75 105.15 60.94 86.53 56.74 86.57 56.55"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.16 60.88 105.12 61.06 86.5 56.86 86.54 56.68"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.13 61 105.09 61.18 86.47 56.98 86.51 56.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.1 61.12 105.06 61.3 86.44 57.1 86.48 56.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.08 61.24 105.04 61.42 86.42 57.23 86.46 57.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.05 61.36 105.01 61.55 86.39 57.35 86.43 57.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.02 61.49 104.98 61.67 86.36 57.47 86.4 57.29"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.99 61.61 104.95 61.79 86.33 57.59 86.37 57.41"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.97 61.73 104.93 61.91 86.31 57.71 86.35 57.53"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.94 61.85 104.9 62.04 86.28 57.84 86.32 57.65"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.91 61.97 104.87 62.16 86.25 57.96 86.29 57.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.88 62.1 104.84 62.28 86.22 58.08 86.26 57.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.86 62.22 104.82 62.4 86.2 58.2 86.24 58.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.83 62.34 104.79 62.52 86.17 58.32 86.21 58.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.8 62.46 104.76 62.64 86.14 58.45 86.18 58.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.77 62.58 104.73 62.77 86.11 58.57 86.15 58.39"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.75 62.71 104.7 62.89 86.09 58.69 86.13 58.51"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.72 62.83 104.68 63.01 86.06 58.81 86.1 58.63"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.69 62.95 104.65 63.13 86.03 58.93 86.07 58.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.66 63.07 104.62 63.26 86 59.06 86.04 58.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.64 63.19 104.59 63.38 85.98 59.18 86.02 59"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.61 63.32 104.57 63.5 85.95 59.3 85.99 59.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.58 63.44 104.54 63.62 85.92 59.42 85.96 59.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.55 63.56 104.51 63.74 85.89 59.54 85.93 59.36"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.53 63.68 104.48 63.87 85.87 59.67 85.91 59.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.5 63.8 104.46 63.99 85.84 59.79 85.88 59.61"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.47 63.93 104.43 64.11 85.81 59.91 85.85 59.73"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.44 64.05 104.4 64.23 85.78 60.03 85.82 59.85"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.42 64.17 104.37 64.35 85.76 60.15 85.8 59.97"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.39 64.29 104.35 64.48 85.73 60.28 85.77 60.09"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.36 64.41 104.32 64.6 85.7 60.4 85.74 60.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.33 64.54 104.29 64.72 85.67 60.52 85.71 60.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.31 64.66 104.26 64.84 85.65 60.64 85.69 60.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.28 64.78 104.24 64.96 85.62 60.76 85.66 60.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.25 64.9 104.21 65.09 85.59 60.89 85.63 60.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.22 65.02 104.18 65.21 85.56 61.01 85.6 60.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.2 65.15 104.15 65.33 85.54 61.13 85.58 60.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.17 65.27 104.13 65.45 85.51 61.25 85.55 61.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.14 65.39 104.1 65.57 85.48 61.37 85.52 61.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.11 65.51 104.07 65.7 85.45 61.5 85.49 61.31"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.09 65.63 104.04 65.82 85.43 61.62 85.47 61.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.06 65.76 104.02 65.94 85.4 61.74 85.44 61.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.03 65.88 103.99 66.06 85.37 61.86 85.41 61.68"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104 66 103.96 66.18 85.34 61.98 85.38 61.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.98 66.12 103.93 66.31 85.32 62.11 85.36 61.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.95 66.25 103.91 66.43 85.29 62.23 85.33 62.05"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.92 66.37 103.88 66.55 85.26 62.35 85.3 62.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.89 66.49 103.85 66.67 85.23 62.47 85.27 62.29"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.87 66.61 103.82 66.79 85.21 62.6 85.25 62.41"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.84 66.73 103.8 66.92 85.18 62.72 85.22 62.53"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.81 66.85 103.77 67.04 85.15 62.84 85.19 62.66"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.78 66.98 103.74 67.16 85.12 62.96 85.16 62.78"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.76 67.1 103.71 67.28 85.09 63.08 85.14 62.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.73 67.22 103.69 67.4 85.07 63.21 85.11 63.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.7 67.34 103.66 67.53 85.04 63.33 85.08 63.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.67 67.47 103.63 67.65 85.01 63.45 85.05 63.27"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.65 67.59 103.6 67.77 84.99 63.57 85.03 63.39"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.62 67.71 103.58 67.89 84.96 63.69 85 63.51"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.59 67.83 103.55 68.01 84.93 63.82 84.97 63.63"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.56 67.95 103.52 68.14 84.9 63.94 84.94 63.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.53 68.08 103.49 68.26 84.87 64.06 84.92 63.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.51 68.2 103.47 68.38 84.85 64.18 84.89 64"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.48 68.32 103.44 68.5 84.82 64.3 84.86 64.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.45 68.44 103.41 68.62 84.79 64.43 84.83 64.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.43 68.56 103.38 68.75 84.76 64.55 84.81 64.36"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.4 68.69 103.36 68.87 84.74 64.67 84.78 64.49"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.37 68.81 103.33 68.99 84.71 64.79 84.75 64.61"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.34 68.93 103.3 69.11 84.68 64.91 84.72 64.73"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.32 69.05 103.27 69.23 84.65 65.04 84.7 64.85"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.29 69.17 103.25 69.36 84.63 65.16 84.67 64.97"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.26 69.3 103.22 69.48 84.6 65.28 84.64 65.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.23 69.42 103.19 69.6 84.57 65.4 84.61 65.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.2 69.54 103.16 69.72 84.54 65.52 84.59 65.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.18 69.66 103.14 69.84 84.52 65.65 84.56 65.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.15 69.78 103.11 69.97 84.49 65.77 84.53 65.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.12 69.91 103.08 70.09 84.46 65.89 84.5 65.71"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.09 70.03 103.05 70.21 84.43 66.01 84.48 65.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.07 70.15 103.03 70.33 84.41 66.13 84.45 65.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.04 70.27 103 70.46 84.38 66.26 84.42 66.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.01 70.39 102.97 70.58 84.35 66.38 84.39 66.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.99 70.52 102.94 70.7 84.32 66.5 84.37 66.32"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.96 70.64 102.92 70.82 84.3 66.62 84.34 66.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.93 70.76 102.89 70.94 84.27 66.74 84.31 66.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.9 70.88 102.86 71.07 84.24 66.87 84.28 66.68"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.87 71 102.83 71.19 84.21 66.99 84.26 66.81"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.85 71.13 102.81 71.31 84.19 67.11 84.23 66.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.82 71.25 102.78 71.43 84.16 67.23 84.2 67.05"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.79 71.37 102.75 71.55 84.13 67.35 84.17 67.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.76 71.49 102.72 71.68 84.1 67.48 84.15 67.29"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.74 71.61 102.7 71.8 84.08 67.6 84.12 67.42"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.71 71.74 102.67 71.92 84.05 67.72 84.09 67.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.68 71.86 102.64 72.04 84.02 67.84 84.06 67.66"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.65 71.98 102.61 72.16 83.99 67.96 84.04 67.78"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.63 72.1 102.59 72.29 83.97 68.09 84.01 67.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.6 72.22 102.56 72.41 83.94 68.21 83.98 68.03"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.57 72.35 102.53 72.53 83.91 68.33 83.95 68.15"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.54 72.47 102.5 72.65 83.88 68.45 83.93 68.27"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.52 72.59 102.48 72.77 83.86 68.57 83.9 68.39"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.49 72.71 102.45 72.9 83.83 68.7 83.87 68.51"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.46 72.83 102.42 73.02 83.8 68.82 83.84 68.64"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.43 72.96 102.39 73.14 83.77 68.94 83.82 68.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.41 73.08 102.37 73.26 83.75 69.06 83.79 68.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.38 73.2 102.34 73.38 83.72 69.18 83.76 69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.35 73.32 102.31 73.51 83.69 69.31 83.73 69.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.32 73.44 102.28 73.63 83.66 69.43 83.71 69.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.3 73.57 102.26 73.75 83.64 69.55 83.68 69.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.27 73.69 102.23 73.87 83.61 69.67 83.65 69.49"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.24 73.81 102.2 73.99 83.58 69.79 83.62 69.61"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.21 73.93 101.75 76 83.13 71.8 83.59 69.73"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M144.37,140.08c.35-1.84.62-3.78.79-5.83l-21.82,5.63,21.03.2Z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M108.48,81.56c5.66-1.45,13.3,7.13,17.07,19.16,3.77,12.03,2.24,22.95-3.42,24.4-5.66,1.45-13.3-7.13-17.07-19.16-3.77-12.03-2.24-22.95,3.42-24.4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "112.24 128.65 112.11 128.24 132.36 121.76 132.49 122.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "112.14 128.32 112.06 128.08 132.3 121.6 132.38 121.85"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "112.09 128.16 112.01 127.91 132.25 121.44 132.33 121.68"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "112.03 127.99 111.96 127.75 132.2 121.28 132.28 121.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "111.98 127.83 111.9 127.59 132.15 121.12 132.23 121.36"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "111.93 127.67 111.85 127.43 132.1 120.96 132.18 121.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "111.88 127.51 111.8 127.26 132.05 120.79 132.12 121.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "111.83 127.35 111.75 127.1 131.99 120.63 132.07 120.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "111.77 127.18 111.7 126.94 131.94 120.47 132.02 120.71"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "111.72 127.02 111.64 126.78 131.89 120.31 131.97 120.55"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "111.67 126.86 111.59 126.62 131.84 120.14 131.92 120.39"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "111.62 126.7 111.54 126.45 131.79 119.98 131.86 120.23"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "111.57 126.54 111.49 126.29 131.73 119.82 131.81 120.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "111.52 126.37 111.44 126.13 131.68 119.66 131.76 119.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "111.46 126.21 111.39 125.97 131.63 119.5 131.71 119.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "111.41 126.05 111.33 125.81 131.58 119.33 131.66 119.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "111.36 125.89 111.28 125.64 131.53 119.17 131.61 119.41"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "111.31 125.73 111.23 125.48 131.48 119.01 131.55 119.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "111.26 125.56 111.18 125.32 131.42 118.85 131.5 119.09"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "111.2 125.4 111.13 125.16 131.37 118.69 131.45 118.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "111.15 125.24 111.07 125 131.32 118.52 131.4 118.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "111.1 125.08 111.02 124.83 131.27 118.36 131.35 118.61"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "111.05 124.91 110.97 124.67 131.22 118.2 131.29 118.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "111 124.75 110.92 124.51 131.16 118.04 131.24 118.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "110.95 124.59 110.87 124.35 131.11 117.88 131.19 118.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "110.89 124.43 110.82 124.19 131.06 117.71 131.14 117.96"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "110.84 124.27 110.76 124.02 131.01 117.55 131.09 117.79"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "110.79 124.11 110.71 123.86 130.96 117.39 131.04 117.63"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "110.74 123.94 110.66 123.7 130.91 117.23 130.98 117.47"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "110.69 123.78 110.61 123.54 130.85 117.07 130.93 117.31"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "110.64 123.62 110.56 123.38 130.8 116.9 130.88 117.15"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "110.58 123.46 110.51 123.21 130.75 116.74 130.83 116.99"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "110.53 123.29 110.45 123.05 130.7 116.58 130.78 116.82"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "110.48 123.13 110.4 122.89 130.65 116.42 130.72 116.66"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "110.43 122.97 110.35 122.73 130.6 116.26 130.67 116.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "110.38 122.81 110.3 122.57 130.54 116.09 130.62 116.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "110.32 122.65 110.25 122.4 130.49 115.93 130.57 116.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "110.27 122.49 110.19 122.24 130.44 115.77 130.52 116.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "110.22 122.32 110.14 122.08 130.39 115.61 130.47 115.85"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "110.17 122.16 110.09 121.92 130.34 115.45 130.41 115.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "110.12 122 110.04 121.76 130.28 115.28 130.36 115.53"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "110.07 121.84 109.99 121.59 130.23 115.12 130.31 115.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "110.01 121.67 109.94 121.43 130.18 114.96 130.26 115.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "109.96 121.51 109.88 121.27 130.13 114.8 130.21 115.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "109.91 121.35 109.83 121.11 130.08 114.64 130.16 114.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "109.86 121.19 109.78 120.95 130.03 114.47 130.1 114.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "109.81 121.03 109.73 120.78 129.97 114.31 130.05 114.55"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "109.75 120.86 109.68 120.62 129.92 114.15 130 114.39"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "109.7 120.7 109.62 120.46 129.87 113.99 129.95 114.23"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "109.65 120.54 109.57 120.3 129.82 113.83 129.9 114.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "109.6 120.38 109.52 120.14 129.77 113.66 129.84 113.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "109.55 120.22 109.47 119.97 129.71 113.5 129.79 113.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "109.5 120.05 109.42 119.81 129.66 113.34 129.74 113.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "109.44 119.89 109.37 119.65 129.61 113.18 129.69 113.42"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "109.39 119.73 109.31 119.49 129.56 113.02 129.64 113.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "109.34 119.57 109.26 119.33 129.51 112.85 129.59 113.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "109.29 119.41 109.21 119.16 129.46 112.69 129.53 112.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "109.24 119.24 109.16 119 129.4 112.53 129.48 112.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "109.18 119.08 109.11 118.84 129.35 112.37 129.43 112.61"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "109.13 118.92 109.05 118.68 129.3 112.21 129.38 112.45"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "109.08 118.76 109 118.52 129.25 112.04 129.33 112.29"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "109.03 118.6 108.95 118.35 129.2 111.88 129.27 112.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "108.98 118.43 108.9 118.19 129.15 111.72 129.22 111.96"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "108.93 118.27 108.85 118.03 129.09 111.56 129.17 111.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "108.87 118.11 108.8 117.87 129.04 111.4 129.12 111.64"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "108.82 117.95 108.74 117.71 128.99 111.23 129.07 111.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "108.77 117.79 108.69 117.54 128.94 111.07 129.02 111.31"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "108.72 117.62 108.64 117.38 128.89 110.91 128.96 111.15"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "108.67 117.46 108.59 117.22 128.83 110.75 128.91 110.99"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "108.62 117.3 108.54 117.06 128.78 110.58 128.86 110.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "108.56 117.14 108.49 116.89 128.73 110.42 128.81 110.67"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "108.51 116.98 108.43 116.73 128.68 110.26 128.76 110.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "108.46 116.81 108.38 116.57 128.63 110.1 128.7 110.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "108.41 116.65 108.33 116.41 128.58 109.94 128.65 110.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "108.36 116.49 108.28 116.25 128.52 109.78 128.6 110.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "108.3 116.33 108.23 116.08 128.47 109.61 128.55 109.86"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "108.25 116.17 108.17 115.92 128.42 109.45 128.5 109.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "108.2 116 108.12 115.76 128.37 109.29 128.45 109.53"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "108.15 115.84 108.07 115.6 128.32 109.13 128.39 109.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "108.1 115.68 108.02 115.44 128.26 108.96 128.34 109.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "108.05 115.52 107.97 115.27 128.21 108.8 128.29 109.05"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.99 115.36 107.92 115.11 128.16 108.64 128.24 108.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.94 115.19 107.86 114.95 128.11 108.48 128.19 108.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.89 115.03 107.81 114.79 128.06 108.32 128.14 108.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.84 114.87 107.76 114.63 128.01 108.15 128.08 108.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.79 114.71 107.71 114.46 127.95 107.99 128.03 108.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.73 114.54 107.66 114.3 127.9 107.83 127.98 108.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.68 114.38 107.6 114.14 127.85 107.67 127.93 107.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.63 114.22 107.55 113.98 127.8 107.51 127.88 107.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.58 114.06 107.5 113.82 127.75 107.34 127.82 107.59"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.53 113.9 107.45 113.65 127.69 107.18 127.77 107.43"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.48 113.74 107.4 113.49 127.64 107.02 127.72 107.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.42 113.57 107.35 113.33 127.59 106.86 127.67 107.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.37 113.41 107.29 113.17 127.54 106.7 127.62 106.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.32 113.25 107.24 113.01 127.49 106.53 127.57 106.78"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.27 113.09 107.19 112.84 127.44 106.37 127.51 106.62"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.22 112.92 107.14 112.68 127.38 106.21 127.46 106.45"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.16 112.76 107.09 112.52 127.33 106.05 127.41 106.29"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.11 112.6 107.03 112.36 127.28 105.89 127.36 106.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.06 112.44 106.98 112.2 127.23 105.72 127.31 105.97"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "107.01 112.28 106.93 112.03 127.18 105.56 127.25 105.81"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.96 112.12 106.88 111.87 127.13 105.4 127.2 105.64"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.91 111.95 106.83 111.71 127.07 105.24 127.15 105.48"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.85 111.79 106.78 111.55 127.02 105.08 127.1 105.32"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.8 111.63 106.72 111.39 126.97 104.91 127.05 105.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.75 111.47 106.67 111.22 126.92 104.75 127 105"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.7 111.3 106.62 111.06 126.87 104.59 126.94 104.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.65 111.14 106.57 110.9 126.81 104.43 126.89 104.67"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.59 110.98 106.52 110.74 126.76 104.27 126.84 104.51"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.54 110.82 106.47 110.58 126.71 104.1 126.79 104.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.49 110.66 106.41 110.41 126.66 103.94 126.74 104.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.44 110.49 106.36 110.25 126.61 103.78 126.68 104.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.39 110.33 106.31 110.09 126.56 103.62 126.63 103.86"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.34 110.17 106.26 109.93 126.5 103.46 126.58 103.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.28 110.01 106.21 109.77 126.45 103.29 126.53 103.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.23 109.85 106.15 109.6 126.4 103.13 126.48 103.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.18 109.68 106.1 109.44 126.35 102.97 126.43 103.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.13 109.52 106.05 109.28 126.3 102.81 126.37 103.05"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.08 109.36 106 109.12 126.24 102.65 126.32 102.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "106.03 109.2 105.95 108.96 126.19 102.48 126.27 102.73"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.97 109.04 105.9 108.79 126.14 102.32 126.22 102.56"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.92 108.87 105.84 108.63 126.09 102.16 126.17 102.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.87 108.71 105.79 108.47 126.04 102 126.12 102.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.82 108.55 105.74 108.31 125.99 101.84 126.06 102.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.77 108.39 105.69 108.15 125.93 101.67 126.01 101.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.71 108.23 105.64 107.98 125.88 101.51 125.96 101.75"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.66 108.06 105.58 107.82 125.83 101.35 125.91 101.59"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.61 107.9 105.53 107.66 125.78 101.19 125.86 101.43"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.56 107.74 105.48 107.5 125.73 101.03 125.8 101.27"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.51 107.58 105.43 107.33 125.67 100.86 125.75 101.11"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.46 107.42 105.38 107.17 125.62 100.7 125.7 100.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.4 107.25 105.33 107.01 125.57 100.54 125.65 100.78"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.35 107.09 105.27 106.85 125.52 100.38 125.6 100.62"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.3 106.93 105.22 106.69 125.47 100.22 125.55 100.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.25 106.77 105.17 106.53 125.42 100.05 125.49 100.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.2 106.61 105.12 106.36 125.36 99.89 125.44 100.13"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.14 106.44 105.07 106.2 125.31 99.73 125.39 99.97"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.09 106.28 105.01 106.04 125.26 99.57 125.34 99.81"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "105.04 106.12 104.96 105.88 125.21 99.41 125.29 99.65"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.99 105.96 104.91 105.71 125.16 99.24 125.23 99.49"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.94 105.8 104.86 105.55 125.1 99.08 125.18 99.32"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.89 105.63 104.81 105.39 125.05 98.92 125.13 99.16"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.83 105.47 104.76 105.23 125 98.76 125.08 99"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.78 105.31 104.7 105.07 124.95 98.6 125.03 98.84"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.73 105.15 104.65 104.9 124.9 98.43 124.98 98.68"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.68 104.99 104.6 104.74 124.85 98.27 124.92 98.51"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.63 104.82 104.55 104.58 124.79 98.11 124.87 98.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.57 104.66 104.5 104.42 124.74 97.95 124.82 98.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.52 104.5 104.45 104.26 124.69 97.78 124.77 98.03"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.47 104.34 104.39 104.09 124.64 97.62 124.72 97.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.42 104.18 104.34 103.93 124.59 97.46 124.66 97.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.37 104.01 104.29 103.77 124.53 97.3 124.61 97.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.32 103.85 104.24 103.61 124.48 97.14 124.56 97.38"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.26 103.69 104.19 103.45 124.43 96.97 124.51 97.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.21 103.53 104.13 103.28 124.38 96.81 124.46 97.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.16 103.37 104.08 103.12 124.33 96.65 124.41 96.89"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.11 103.2 104.03 102.96 124.28 96.49 124.35 96.73"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104.06 103.04 103.98 102.8 124.22 96.33 124.3 96.57"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "104 102.88 103.93 102.64 124.17 96.16 124.25 96.41"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.95 102.72 103.88 102.47 124.12 96 124.2 96.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.9 102.56 103.82 102.31 124.07 95.84 124.15 96.08"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.85 102.39 103.77 102.15 124.02 95.68 124.09 95.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.8 102.23 103.72 101.99 123.97 95.52 124.04 95.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.75 102.07 103.67 101.83 123.91 95.35 123.99 95.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.69 101.91 103.62 101.66 123.86 95.19 123.94 95.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.64 101.75 103.56 101.5 123.81 95.03 123.89 95.27"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.59 101.58 103.51 101.34 123.76 94.87 123.84 95.11"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.54 101.42 103.46 101.18 123.71 94.71 123.78 94.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.49 101.26 103.41 101.02 123.65 94.54 123.73 94.79"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.44 101.1 103.36 100.85 123.6 94.38 123.68 94.62"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.38 100.94 103.31 100.69 123.55 94.22 123.63 94.46"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.33 100.77 103.25 100.53 123.5 94.06 123.58 94.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.28 100.61 103.2 100.37 123.45 93.9 123.53 94.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.23 100.45 103.15 100.21 123.4 93.73 123.47 93.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.18 100.29 103.1 100.04 123.34 93.57 123.42 93.81"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.12 100.12 103.05 99.88 123.29 93.41 123.37 93.65"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.07 99.96 102.99 99.72 123.24 93.25 123.32 93.49"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "103.02 99.8 102.94 99.56 123.19 93.09 123.27 93.33"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.97 99.64 102.89 99.4 123.14 92.92 123.21 93.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.92 99.48 102.84 99.23 123.08 92.76 123.16 93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.87 99.31 102.79 99.07 123.03 92.6 123.11 92.84"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.81 99.15 102.74 98.91 122.98 92.44 123.06 92.68"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.76 98.99 102.68 98.75 122.93 92.28 123.01 92.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.71 98.83 102.63 98.59 122.88 92.11 122.96 92.36"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.66 98.67 102.58 98.42 122.83 91.95 122.9 92.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.61 98.5 102.53 98.26 122.77 91.79 122.85 92.03"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.55 98.34 102.48 98.1 122.72 91.63 122.8 91.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.5 98.18 102.43 97.94 122.67 91.47 122.75 91.71"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.45 98.02 102.37 97.78 122.62 91.3 122.7 91.55"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.4 97.86 102.32 97.61 122.57 91.14 122.64 91.38"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.35 97.69 102.27 97.45 122.52 90.98 122.59 91.22"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.3 97.53 102.22 97.29 122.46 90.82 122.54 91.06"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.24 97.37 102.17 97.13 122.41 90.66 122.49 90.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.19 97.21 102.11 96.97 122.36 90.49 122.44 90.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.14 97.05 102.06 96.8 122.31 90.33 122.39 90.57"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.09 96.88 102.01 96.64 122.26 90.17 122.33 90.41"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "102.04 96.72 101.96 96.48 122.2 90.01 122.28 90.25"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "101.99 96.56 101.91 96.32 122.15 89.85 122.23 90.09"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "101.93 96.4 101.86 96.16 122.1 89.68 122.18 89.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "101.88 96.24 101.8 95.99 122.05 89.52 122.13 89.76"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "101.83 96.07 101.75 95.83 122 89.36 122.07 89.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "101.78 95.91 101.7 95.67 121.95 89.2 122.02 89.44"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "101.73 95.75 101.65 95.51 121.89 89.04 121.97 89.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "101.67 95.59 101.6 95.35 121.84 88.87 121.92 89.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "101.62 95.43 101.54 95.18 121.79 88.71 121.87 88.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "101.57 95.26 101.49 95.02 121.74 88.55 121.82 88.79"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "101.52 95.1 101.44 94.86 121.69 88.39 121.76 88.63"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "101.47 94.94 101.39 94.7 121.63 88.23 121.71 88.47"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "101.42 94.78 101.34 94.54 121.58 88.06 121.66 88.31"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "101.36 94.62 101.29 94.37 121.53 87.9 121.61 88.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "101.31 94.45 101.23 94.21 121.48 87.74 121.56 87.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "101.26 94.29 101.18 94.05 121.43 87.58 121.51 87.82"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "101.21 94.13 101.13 93.89 121.38 87.41 121.45 87.66"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "101.16 93.97 101.08 93.73 121.32 87.25 121.4 87.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "101.1 93.81 101.03 93.56 121.27 87.09 121.35 87.33"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "101.05 93.64 100.97 93.4 121.22 86.93 121.3 87.17"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "101 93.48 100.92 93.24 121.17 86.77 121.25 87.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "100.95 93.32 100.87 93.08 121.12 86.6 121.19 86.85"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "100.9 93.16 100.82 92.91 121.06 86.44 121.14 86.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "100.85 93 100.77 92.75 121.01 86.28 121.09 86.52"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "100.79 92.83 100.72 92.59 120.96 86.12 121.04 86.36"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "100.74 92.67 100.66 92.43 120.91 85.96 120.99 86.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "100.69 92.51 100.61 92.27 120.86 85.79 120.94 86.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "100.64 92.35 100.56 92.1 120.81 85.63 120.88 85.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "100.59 92.19 100.51 91.94 120.75 85.47 120.83 85.71"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "100.53 92.02 100.46 91.78 120.7 85.31 120.78 85.55"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "100.48 91.86 100.41 91.62 120.65 85.15 120.73 85.39"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "100.43 91.7 100.35 91.46 120.6 84.98 120.68 85.23"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "100.38 91.54 100.3 91.29 120.55 84.82 120.62 85.07"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "100.33 91.38 100.25 91.13 120.5 84.66 120.57 84.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "100.28 91.21 100.2 90.97 120.44 84.5 120.52 84.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "100.22 91.05 100.15 90.81 120.39 84.34 120.47 84.58"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "100.17 90.89 100.09 90.65 120.34 84.17 120.42 84.42"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "100.12 90.73 100.04 90.48 120.29 84.01 120.37 84.26"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "100.07 90.57 99.99 90.32 120.24 83.85 120.31 84.09"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "100.02 90.4 99.94 90.16 120.18 83.69 120.26 83.93"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "99.97 90.24 99.89 90 120.13 83.53 120.21 83.77"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "99.91 90.08 99.84 89.84 120.08 83.36 120.16 83.61"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "99.86 89.92 99.78 89.67 120.03 83.2 120.11 83.45"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "99.81 89.76 99.73 89.51 119.98 83.04 120.05 83.28"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "99.76 89.59 99.68 89.35 119.93 82.88 120 83.12"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "99.71 89.43 99.63 89.19 119.87 82.72 119.95 82.96"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "99.65 89.27 99.58 89.03 119.82 82.55 119.9 82.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "99.6 89.11 99.52 88.86 119.77 82.39 119.85 82.64"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "99.55 88.95 99.47 88.7 119.72 82.23 119.8 82.47"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "99.5 88.78 99.42 88.54 119.67 82.07 119.74 82.31"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "99.45 88.62 99.37 88.38 119.61 81.91 119.69 82.15"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "99.4 88.46 99.32 88.22 119.56 81.74 119.64 81.99"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "99.34 88.3 99.27 88.05 119.51 81.58 119.59 81.83"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "99.29 88.13 99.21 87.89 119.46 81.42 119.54 81.66"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "99.24 87.97 99.16 87.73 119.41 81.26 119.49 81.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "99.19 87.81 99.11 87.57 119.36 81.1 119.43 81.34"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "99.14 87.65 99.06 87.41 119.3 80.93 119.38 81.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "99.08 87.49 99.01 87.24 119.25 80.77 119.33 81.01"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "99.03 87.32 98.95 87.08 119.2 80.61 119.28 80.85"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "98.98 87.16 98.13 84.5 118.38 78.03 119.23 80.69"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M111.17,88.39c3.83-.98,9,4.78,11.53,12.85,2.54,8.08,1.49,15.42-2.35,16.4-3.83.98-9-4.78-11.53-12.86-2.54-8.08-1.49-15.42,2.35-16.4"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "167.02 4.21 135.92 19.69 148.63 26.36 123.71 46.64 163.23 24.59 152.32 19.49 167.02 4.21"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "191.81 181.49 193 171.32 163.72 166.32 191.81 181.49"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "171.36 184.32 155.14 169.72 163.05 186.7 171.36 184.32"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "120.05 22.06 113.92 21.99 112.77 39.76 120.05 22.06"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M144.9,176.34c-5.26.76-6.26,1.83-6.68,7.13,0,.12-.11.21-.23.21-.12,0-.22-.08-.24-.2-.76-5.25-1.83-6.26-7.13-6.68-.12,0-.21-.11-.22-.23,0-.12.08-.22.2-.24,5.25-.76,6.26-1.83,6.68-7.13,0-.12.11-.21.22-.21.12,0,.22.08.24.2.76,5.25,1.83,6.26,7.13,6.68.12,0,.21.11.22.23,0,.12-.08.22-.2.24"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M164.12,34.23c2.14-.07,3.92,1.61,3.99,3.74.07,2.14-1.61,3.92-3.74,3.99-2.14.07-3.92-1.61-3.99-3.74-.07-2.14,1.61-3.92,3.74-3.99"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M128.97,183.53c1.17-.04,2.14.88,2.18,2.04.04,1.17-.88,2.14-2.04,2.18-1.17.04-2.14-.88-2.18-2.04-.04-1.17.88-2.14,2.04-2.18Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "104.33 0 94.89 3.96 104.93 31.91 104.33 0"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "226.27 72.16 178.01 78.84 191.92 93.39 149.73 109.21 212.12 97.57 199.89 85.91 226.27 72.16"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "155.33 133.7 155.92 142.29 180.89 141.87 155.33 133.7"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "139.28 68.38 148.76 79.17 181.45 53.35 139.28 68.38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralPic);
export default __webpack_public_path__ + "static/media/referral-pic.f01d11f0820fbe759a66f67757daae8f.svg";
export { ForwardRef as ReactComponent };